var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdroL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 186,
    viewBox: "0 0 187 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.667 99.118C172.213 100.831 171.901 102.627 171.73 104.508C171.847 105.347 171.847 106.167 171.73 106.968C171.329 108.462 170.938 109.986 170.558 111.538C170.59 111.958 170.512 112.348 170.324 112.709C170.324 112.944 170.324 113.178 170.324 113.412C169.756 114.826 169.209 116.271 168.684 117.747C168.7 117.927 168.778 118.044 168.918 118.099C168.918 118.177 168.918 118.255 168.918 118.333C168.304 118.886 168.148 119.55 168.449 120.325C168.293 120.637 168.059 120.872 167.746 121.028C167.877 121.118 167.955 121.235 167.981 121.38C166.348 125.895 164.2 130.191 161.536 134.268C159.823 136.284 158.339 138.471 157.084 140.829C155.295 142.853 153.42 144.806 151.46 146.687C152.504 144.457 153.91 142.426 155.678 140.595C156.751 138.682 157.884 136.808 159.076 134.971C159.697 134.275 160.126 133.494 160.365 132.627C159.855 133.337 159.347 134.04 158.842 134.736C157.916 135.641 157.096 136.656 156.381 137.783C156.754 136.724 157.262 135.708 157.904 134.736C156.97 135.634 156.15 136.65 155.444 137.783C155.287 137.548 155.287 137.314 155.444 137.08C157.608 133.166 159.639 129.183 161.536 125.129C161.913 122.983 162.616 120.952 163.645 119.036C164.238 116.517 164.902 114.018 165.637 111.538C165.938 109.933 166.133 108.293 166.223 106.617C165.994 107.881 165.72 109.131 165.403 110.366C162.297 122.789 156.36 133.607 147.594 142.821C147.437 142.977 147.281 142.977 147.125 142.821C163.077 123.659 168.818 101.749 164.348 77.0908C161.636 64.7159 156.247 53.7023 148.179 44.0499C146.609 42.4403 145.008 40.878 143.376 39.3633C136.067 32.3839 127.631 27.1115 118.068 23.5459C115.011 22.3833 111.887 21.4851 108.695 20.851C84.7252 15.9938 63.4792 21.5006 44.9562 37.3715C42.7917 39.4181 40.7607 41.566 38.8636 43.8156C34.7576 48.3492 31.2817 53.3482 28.4358 58.8128C28.2795 59.0472 28.2795 59.2815 28.4358 59.5158C31.4125 53.8701 34.9664 48.6365 39.0979 43.8156C39.9159 43.1149 40.697 42.3728 41.4412 41.5894C41.6362 41.4282 41.7922 41.4673 41.9099 41.7066C23.62 62.4569 17.9569 86.2806 24.9208 113.178C29.1355 126.768 36.6341 138.172 47.4167 147.39C47.6447 147.834 47.801 148.302 47.8853 148.796C49.0823 149.563 49.9805 150.578 50.5802 151.843C67.5751 163.562 86.3217 167.897 106.82 164.848C110.07 164.289 113.273 163.547 116.427 162.622C116.662 162.7 116.818 162.856 116.896 163.091C115.335 163.457 113.773 163.809 112.21 164.145C111.536 164.318 110.911 164.591 110.335 164.965C109.53 164.774 108.671 164.93 107.757 165.434C107.62 165.385 107.503 165.307 107.406 165.2C105.197 165.997 102.932 166.232 100.61 165.903C100.188 166.095 99.7585 166.251 99.3212 166.371C95.9611 166.639 92.6022 166.678 89.245 166.488C91.1058 166.746 92.9804 166.863 94.8689 166.84C96.4722 166.84 98.0345 166.762 99.5556 166.606C106.036 166.308 112.285 165.058 118.302 162.856C119.433 162.689 120.448 162.299 121.348 161.685C123.091 161.112 124.81 160.487 126.504 159.81C127.11 159.819 127.579 159.585 127.91 159.107C128.924 158.483 130.018 158.053 131.19 157.818C131.668 157.262 132.215 156.793 132.831 156.412C133.918 155.955 135.012 155.486 136.111 155.006C137.489 153.971 138.895 152.994 140.329 152.077C140.329 152.311 140.329 152.546 140.329 152.78C138.513 154.13 136.638 155.379 134.705 156.529C134.509 156.61 134.431 156.766 134.471 156.998C132.684 157.857 130.965 158.794 129.316 159.81C128.202 160.094 127.187 160.562 126.269 161.216C126.096 161.185 125.94 161.224 125.801 161.333C126.084 161.577 126.319 161.85 126.504 162.153C124.253 163.087 121.988 164.024 119.708 164.965C115.132 166.363 110.523 167.574 105.883 168.597C110.927 168.195 115.77 167.063 120.411 165.2C122.212 164.638 124.008 164.053 125.801 163.442C126.638 163.075 127.419 162.607 128.144 162.036C128.447 161.921 128.76 161.882 129.081 161.919C129.261 162.098 129.379 162.332 129.433 162.622C129.803 162.317 130.076 162.396 130.253 162.856C130.147 163.081 129.991 163.276 129.784 163.442C128.185 163.765 126.857 164.507 125.801 165.668C125.128 165.739 124.503 165.895 123.926 166.137C123.584 166.121 123.272 166.199 122.989 166.371C122.508 166.348 122.117 166.505 121.817 166.84C120.968 167.111 120.109 167.345 119.239 167.543C119.007 167.503 118.851 167.581 118.771 167.777C116.58 168.11 114.471 168.696 112.444 169.535C113.381 169.497 114.319 169.38 115.256 169.183C115.178 169.34 115.1 169.496 115.021 169.652C111.579 170.709 108.064 171.412 104.477 171.761C103.956 171.836 103.526 171.68 103.188 171.292C102.56 171.653 101.897 171.888 101.196 171.995C99.7128 172.089 98.2288 172.167 96.7436 172.23C93.6403 172.24 90.516 172.24 87.3703 172.23C86.2221 171.817 85.0504 171.739 83.8553 171.995C81.886 171.662 79.9331 171.271 77.997 170.824C77.971 170.679 77.893 170.562 77.7627 170.472C77.2214 170.356 76.6747 170.317 76.1224 170.355C74.6505 170.182 73.2445 169.792 71.9044 169.183C71.6654 168.843 71.3919 168.765 71.0842 168.949C70.4452 168.645 69.7813 168.41 69.0924 168.246C67.8038 167.759 66.4758 167.407 65.1087 167.191C64.4454 166.982 63.8204 166.552 63.2341 165.903C62.9016 165.68 62.5112 165.602 62.0624 165.668C61.4194 165.433 60.7164 165.238 59.9534 165.082C59.68 164.809 59.4067 164.536 59.1333 164.262C59.0611 164.452 58.9439 164.608 58.7818 164.731C58.1139 164.279 57.489 163.772 56.9071 163.208C55.3357 162.679 53.8514 161.976 52.4548 161.099C48.7125 158.397 45.1193 155.741 41.6755 153.132C38.1109 149.684 34.6739 146.13 31.3649 142.469C29.2522 139.179 27.026 135.976 24.6865 132.862C23.6992 130.888 22.723 128.935 21.7573 127.004C21.7142 126.339 21.4016 125.87 20.82 125.598C19.7235 122.385 18.591 119.182 17.4222 115.99C16.4476 112.561 15.5491 109.124 14.7273 105.679C14.9005 105.71 15.0568 105.671 15.196 105.562C15.0589 105.257 14.9029 104.984 14.7273 104.742C14.3904 100.862 13.9997 96.9954 13.5557 93.1425C13.7816 90.7694 13.8596 88.3872 13.79 85.9954C13.9468 83.964 14.1811 81.933 14.493 79.9027C14.5115 79.5677 14.4335 79.2551 14.2587 78.9654C14.4656 78.7198 14.6219 78.4464 14.7273 78.1453C14.7557 77.1369 14.7557 76.1216 14.7273 75.0989C14.9 74.443 15.0952 74.4039 15.3132 74.9818C15.4292 74.5194 15.4683 74.0508 15.4303 73.5758C15.6281 72.9091 15.7842 72.2061 15.899 71.4668C15.6736 70.6457 15.7516 69.8647 16.1333 69.1235C16.0965 69.4452 16.1357 69.7578 16.2505 70.0608C16.3831 69.5399 16.5786 69.0712 16.8363 68.6548C17.3223 68.1358 17.4004 67.5499 17.0707 66.8973C17.2462 66.491 17.3633 66.0614 17.4222 65.6085C17.5002 65.6865 17.5785 65.7648 17.6565 65.8428C17.9375 65.0869 18.0546 64.3058 18.008 63.4995C18.5507 62.034 19.0585 60.5497 19.5311 59.0472C20.5402 57.5001 21.4384 55.8598 22.226 54.1262C22.7551 53.4567 23.2238 52.7537 23.632 52.0172C24.0193 52.5653 24.3319 52.4482 24.5693 51.6657C24.4301 51.557 24.2738 51.5179 24.1006 51.5485C25.811 49.0126 27.4905 46.435 29.1388 43.8156C30.9345 41.7856 32.8091 39.8326 34.7627 37.9573C34.8366 38.2872 34.7585 38.5996 34.5284 38.8946C33.2902 40.68 31.9622 42.3983 30.5448 44.0499C29.3874 46.0654 28.1377 48.0183 26.7954 49.9082C26.6342 50.1032 26.6734 50.2593 26.9126 50.3769C28.0006 49.2917 28.9771 48.12 29.8418 46.8619C29.2512 48.1196 28.5874 49.3693 27.8499 50.6112C28.6914 49.4939 29.5899 48.4003 30.5448 47.3306C30.5839 47.4086 30.6228 47.4869 30.6619 47.5649C27.517 53.3072 24.8221 59.2435 22.5775 65.3741C21.9225 67.8862 21.2195 70.3858 20.4685 72.8728C20.101 75.7635 19.7495 78.6535 19.414 81.5431C19.2265 83.5166 18.9922 85.5084 18.711 87.5185C18.8281 87.6357 18.9453 87.7529 19.0625 87.87C19.264 86.068 19.4592 84.2716 19.6483 82.4804C22.2302 63.6049 30.6661 47.9436 44.9562 35.4968C47.198 33.6817 49.4631 31.9242 51.7518 30.2243C52.5579 29.8599 53.339 29.4304 54.0951 28.9355C53.9559 28.8268 53.7996 28.7876 53.6265 28.8183C55.4393 27.6 57.3139 26.5066 59.2504 25.5377C57.8262 25.8978 56.4202 26.3274 55.0325 26.8265C54.535 27.3526 53.9883 27.8212 53.3921 28.2325C52.1947 28.7141 51.023 29.2608 49.8772 29.8728C47.8699 31.2978 45.8389 32.6647 43.7845 33.9736C44.4578 33.3618 45.0825 32.6979 45.6592 31.9818C47.4551 30.6928 49.3298 29.5211 51.2832 28.4668C51.5932 28.2756 51.7492 28.0022 51.7518 27.6467C53.3858 26.8767 55.0261 26.0956 56.6728 25.3033C57.7301 24.6573 58.8237 24.0715 59.9534 23.5459C59.7313 23.4327 59.497 23.3938 59.2504 23.4287C59.4681 23.2377 59.7025 23.0425 59.9534 22.8429C59.8232 22.7531 59.7451 22.6359 59.7191 22.4914C62.0531 21.5055 64.3964 20.5682 66.7491 19.6794C71.1505 18.298 75.6028 17.1263 80.106 16.1644C77.6865 16.3066 75.2652 16.6581 72.8417 17.2189C70.4351 17.8523 68.0918 18.5944 65.8117 19.445C63.6552 20.2486 61.4682 20.9907 59.2504 21.6712C59.0161 21.9055 58.7818 22.1399 58.5475 22.3742C56.139 23.2658 53.8739 24.3986 51.7518 25.772C51.5266 25.3584 51.4484 24.8898 51.5175 24.366C53.1025 23.2982 54.7428 22.2828 56.4385 21.3197C56.6076 21.4177 56.7248 21.5737 56.79 21.7884C57.3784 21.4254 57.9642 21.035 58.5475 20.6167C59.4016 19.9985 60.5861 19.7153 61.4503 19.0835C62.3113 18.5864 62.355 18.6664 62.9985 18.2853C63.6856 17.9843 63.912 18.0449 64.4058 17.8047C65.3672 17.6665 66.3045 17.4321 67.2177 17.1017C67.374 17.1017 67.4521 17.0237 67.4521 16.8674C68.7022 16.6331 69.9519 16.3987 71.2014 16.1644C72.7163 15.6111 74.2786 15.1816 75.888 14.8756C76.0183 14.7859 76.0964 14.6687 76.1224 14.5241C75.799 14.2413 75.5255 14.3195 75.3022 14.7584C75.2052 14.6512 75.088 14.5731 74.9507 14.5241C73.5923 14.8909 72.2646 15.2814 70.9671 15.6957C70.8108 15.6957 70.6547 15.6957 70.4984 15.6957C69.9833 15.7171 69.9053 15.561 70.2641 15.2271C77.0658 13.2742 84.0177 12.3369 91.1196 12.4151C91.3996 12.4567 91.6731 12.5348 91.9398 12.6494C92.7248 12.3038 93.545 12.1476 94.4003 12.1807C94.4263 12.3254 94.5043 12.4426 94.6346 12.5322C95.9745 12.7057 97.3025 12.6666 98.6182 12.4151C99.3894 12.5925 100.17 12.7487 100.962 12.8837C101.865 12.8475 102.802 12.9256 103.774 13.1181C105.754 13.1985 107.629 13.511 109.398 14.0554C109.644 14.4669 110.035 14.6231 110.569 14.5241C112.099 14.7233 113.661 15.1139 115.256 15.6957C115.727 16.0625 116.274 16.2968 116.896 16.3987C118.336 16.9616 119.82 17.3911 121.348 17.6876C121.968 17.9322 122.515 18.2837 122.989 18.742C123.263 18.9401 123.576 19.0961 123.926 19.2107C124.317 19.2695 124.669 19.4258 124.981 19.6794C125.827 19.3387 126.49 19.573 126.972 20.3824C127.129 20.3043 127.285 20.2261 127.441 20.148C130.069 21.6909 132.725 23.214 135.408 24.7175C140.317 28.2156 144.965 32.0821 149.351 36.317C149.464 36.5391 149.503 36.7734 149.468 37.02C152.182 39.0917 154.408 41.5913 156.147 44.5186C161.77 51.6903 165.91 59.5013 168.566 67.9518C169.456 71.6983 170.432 75.4087 171.496 79.0826C171.351 79.6785 171.273 80.2643 171.261 80.8401C171.558 82.9331 171.949 85.003 172.433 87.0499C172.297 87.2591 172.219 87.4935 172.199 87.7529C172.353 91.5467 172.509 95.3349 172.667 99.118Z",
    fill: "url(#paint0_linear_2278_3893)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.745 78.2919C171.999 79.7778 172.29 81.3171 172.619 82.9098C172.491 83.2039 172.363 83.4808 172.235 83.7405C171.913 81.8798 171.75 80.0637 171.745 78.2919Z",
    fill: "url(#paint1_linear_2278_3893)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.999 92.0265C173.087 91.6289 173.061 91.2316 172.922 90.8341C173.182 90.435 173.363 90.5077 173.466 91.0523C173.536 91.4282 173.514 91.798 173.399 92.1619C173.279 92.0592 173.146 92.0142 172.999 92.0265Z",
    fill: "url(#paint2_linear_2278_3893)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.036 97.5964C172.887 97.5794 172.781 97.4864 172.719 97.3175C172.845 95.7554 172.999 94.218 173.181 92.7055C173.331 92.7225 173.436 92.8155 173.499 92.9844C173.595 94.6569 173.595 96.3148 173.497 97.9581C173.349 97.5506 173.196 97.4302 173.036 97.5964Z",
    fill: "url(#paint3_linear_2278_3893)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.98 101.008C172.917 100.875 172.812 100.782 172.663 100.729C172.924 100.497 173.09 100.21 173.16 99.8681C172.668 99.197 172.647 98.5151 173.097 97.8229C173.139 98.1324 173.285 98.3763 173.535 98.5544C173.523 99.4321 173.338 100.25 172.98 101.008Z",
    fill: "url(#paint4_linear_2278_3893)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.169 92.1078C168.117 91.6571 167.941 91.3002 167.64 91.0367C167.626 89.7612 167.567 88.4831 167.461 87.2029C167.808 88.8452 168.044 90.4802 168.169 92.1078Z",
    fill: "url(#paint5_linear_2278_3893)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.896 116.441C167.856 116.29 167.76 116.235 167.609 116.275C167.917 115.472 168.226 114.661 168.535 113.844C168.529 114.742 168.316 115.608 167.896 116.441Z",
    fill: "url(#paint6_linear_2278_3893)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.455 113.89C167.361 113.305 167.408 112.727 167.597 112.154C167.83 112.757 167.783 113.336 167.455 113.89Z",
    fill: "url(#paint7_linear_2278_3893)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.456 113.89C167.531 114.397 167.406 114.835 167.08 115.204C167.004 114.697 167.13 114.259 167.456 113.89Z",
    fill: "url(#paint8_linear_2278_3893)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.08 115.204C167.155 115.711 167.03 116.149 166.704 116.518C166.629 116.01 166.754 115.572 167.08 115.204Z",
    fill: "url(#paint9_linear_2278_3893)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.711 128.555C160.967 128.583 161.045 128.724 160.945 128.978C160.804 129.459 160.515 129.739 160.078 129.816C160.344 129.413 160.555 128.992 160.711 128.555Z",
    fill: "url(#paint10_linear_2278_3893)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.777 130.504C159.555 131.294 159.128 131.813 158.496 132.06C158.763 131.404 159.19 130.885 159.777 130.504Z",
    fill: "url(#paint11_linear_2278_3893)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.398 138.495C154.337 138.269 154.277 138.042 154.216 137.816C154.838 137.017 155.421 136.174 155.964 135.286C156.111 135.079 156.271 135.077 156.447 135.277C155.748 136.358 155.065 137.431 154.398 138.495Z",
    fill: "url(#paint12_linear_2278_3893)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.126 141.211C155.108 141.601 154.912 141.774 154.538 141.733C154.643 141.452 154.839 141.279 155.126 141.211Z",
    fill: "url(#paint13_linear_2278_3893)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.026 143.447C153.868 143.774 153.607 144.005 153.242 144.142C153.202 143.991 153.106 143.936 152.955 143.976C152.935 143.901 152.915 143.825 152.895 143.75C153.184 143.362 153.481 142.959 153.784 142.541C153.879 142.596 153.975 142.652 154.071 142.707C153.895 142.956 153.719 143.206 153.543 143.455C153.706 143.524 153.867 143.521 154.026 143.447Z",
    fill: "url(#paint14_linear_2278_3893)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.273 150.836C146.983 150.437 146.699 150.432 146.42 150.822C146.292 150.556 146.119 150.36 145.899 150.234C147.007 149.11 148.173 148.029 149.397 146.992C150.233 145.566 151.399 144.485 152.895 143.75C152.915 143.825 152.935 143.901 152.955 143.976C152.534 144.317 152.152 144.702 151.81 145.132C152.39 144.959 152.868 144.629 153.242 144.142C153.607 144.005 153.868 143.774 154.026 143.447C154.688 143.019 155.228 142.47 155.647 141.799C155.77 141.807 155.894 141.814 156.017 141.822C155.576 142.253 155.225 142.751 154.962 143.317C153.439 144.963 151.835 146.524 150.153 148.002C149.39 149.145 148.43 150.09 147.273 150.836Z",
    fill: "url(#paint15_linear_2278_3893)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.242 144.142C152.868 144.628 152.39 144.959 151.81 145.132C152.152 144.702 152.534 144.317 152.955 143.976C153.106 143.936 153.202 143.991 153.242 144.142Z",
    fill: "url(#paint16_linear_2278_3893)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.616 141.474C149.634 141.085 149.83 140.911 150.205 140.953C150.099 141.233 149.903 141.407 149.616 141.474Z",
    fill: "url(#paint17_linear_2278_3893)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.847 145.052C149.676 145.017 149.505 144.982 149.334 144.947C149.557 144.7 149.723 144.413 149.831 144.086C149.732 143.872 149.767 143.701 149.936 143.572C149.968 143.954 150.265 144.158 150.827 144.183C150.536 144.526 150.21 144.816 149.847 145.052Z",
    fill: "url(#paint18_linear_2278_3893)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.616 141.474C149.09 142.222 148.457 142.877 147.717 143.439C148.137 142.598 148.77 141.943 149.616 141.474Z",
    fill: "url(#paint19_linear_2278_3893)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.847 145.052C149.257 145.751 148.579 146.539 147.812 147.416C147.451 147.606 147.064 147.67 146.65 147.606C147.538 146.726 148.432 145.839 149.334 144.947C149.505 144.982 149.676 145.017 149.847 145.052Z",
    fill: "url(#paint20_linear_2278_3893)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.831 144.086C149.723 144.412 149.557 144.699 149.334 144.947C148.432 145.839 147.538 146.726 146.65 147.606C146.27 147.74 145.912 147.916 145.579 148.136C146.91 146.728 148.327 145.378 149.831 144.086Z",
    fill: "url(#paint21_linear_2278_3893)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.927 148.528C146.085 148.201 146.346 147.969 146.711 147.833C146.949 147.97 146.925 148.179 146.636 148.459C146.421 148.631 146.184 148.654 145.927 148.528Z",
    fill: "url(#paint22_linear_2278_3893)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.039 147.821C143.843 148.368 143.451 148.716 142.863 148.864C142.953 148.597 143.043 148.33 143.134 148.064C143.093 147.913 143.148 147.817 143.299 147.777C143.515 147.938 143.761 147.953 144.039 147.821Z",
    fill: "url(#paint23_linear_2278_3893)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.579 148.136C144.862 149.005 144.002 149.721 143 150.283C143.718 149.414 144.577 148.698 145.579 148.136Z",
    fill: "url(#paint24_linear_2278_3893)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.546 19.9953C109.015 20.2522 108.436 20.205 107.81 19.854C108.38 19.7544 108.959 19.8017 109.546 19.9953Z",
    fill: "url(#paint25_linear_2278_3893)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.65 147.606C146.67 147.682 146.691 147.757 146.711 147.833C146.346 147.969 146.085 148.201 145.927 148.528C145.751 148.543 145.611 148.622 145.504 148.763C145.847 148.833 145.887 148.983 145.626 149.215C144.902 149.857 144.183 150.495 143.469 151.127C143.212 150.882 142.915 150.679 142.578 150.517C142.684 150.376 142.825 150.298 143 150.283C144.002 149.721 144.862 149.005 145.579 148.136C145.912 147.916 146.27 147.74 146.65 147.606Z",
    fill: "url(#paint26_linear_2278_3893)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.134 148.063C143.043 148.33 142.953 148.597 142.863 148.864C141.402 149.957 139.904 151.005 138.368 152.009C139.955 150.694 141.543 149.379 143.134 148.063Z",
    fill: "url(#paint27_linear_2278_3893)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.717 143.439C146.388 145.038 144.915 146.483 143.299 147.777C143.148 147.817 143.093 147.913 143.134 148.064C141.543 149.379 139.955 150.694 138.368 152.009C137.264 152.382 136.384 153.022 135.729 153.929C135.195 153.834 134.762 154.03 134.432 154.519C134.296 154.313 134.104 154.203 133.858 154.188C135.925 152.864 137.977 151.465 140.011 149.992C142.512 147.68 145.081 145.496 147.717 143.439Z",
    fill: "url(#paint28_linear_2278_3893)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.132 156.095C142.183 155.906 142.303 155.753 142.494 155.634C142.331 155.565 142.17 155.568 142.011 155.642C142.505 155.26 143.068 154.947 143.7 154.705C144.029 154.636 144.31 154.479 144.545 154.236C144.837 154.241 144.867 154.355 144.636 154.575C143.888 155.232 143.054 155.738 142.132 156.095Z",
    fill: "url(#paint29_linear_2278_3893)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.088 151.226C128.904 148.678 133.343 145.629 137.406 142.078C137.898 141.826 138.406 141.61 138.929 141.427C139.052 142.156 138.806 142.748 138.192 143.202C129.108 151.575 118.508 156.68 106.391 158.515C106.582 158.211 106.843 157.979 107.175 157.82C113.133 156.41 118.771 154.211 124.088 151.226Z",
    fill: "url(#paint30_linear_2278_3893)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.132 156.095C141.803 156.164 141.522 156.32 141.287 156.564C141.041 156.516 141 156.365 141.166 156.111C141.395 155.872 141.676 155.716 142.011 155.642C142.17 155.568 142.331 155.565 142.494 155.634C142.303 155.753 142.183 155.906 142.132 156.095Z",
    fill: "url(#paint31_linear_2278_3893)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.983 13.7226C103.615 13.7026 103.273 13.6327 102.957 13.5125C102.937 13.3859 102.992 13.2904 103.122 13.2255C103.528 13.2756 103.935 13.2876 104.345 13.2618C104.155 13.3802 104.034 13.5338 103.983 13.7226Z",
    fill: "url(#paint32_linear_2278_3893)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.412 18.9447C104.395 19.0941 104.302 19.1998 104.133 19.2621C103.663 19.2193 103.197 19.1417 102.737 19.0298C103.277 18.8523 103.835 18.824 104.412 18.9447Z",
    fill: "url(#paint33_linear_2278_3893)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.368 152.009C137.657 152.835 136.778 153.475 135.729 153.929C136.384 153.022 137.264 152.382 138.368 152.009Z",
    fill: "url(#paint34_linear_2278_3893)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.155 156.867C139.615 157.533 138.962 158.112 138.195 158.606C137.987 158.551 137.871 158.42 137.848 158.213C138.636 157.797 139.406 157.349 140.155 156.867Z",
    fill: "url(#paint35_linear_2278_3893)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.373 155.647C134.372 158.647 129.987 160.995 125.219 162.689C129.436 160.499 133.574 158.137 137.633 155.602C137.848 155.764 138.095 155.779 138.373 155.647Z",
    fill: "url(#paint36_linear_2278_3893)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.406 142.078C133.343 145.629 128.904 148.678 124.088 151.226C123.96 151.057 123.789 151.022 123.575 151.121C125.908 149.846 128.205 148.463 130.468 146.969C132.56 145.393 134.646 143.823 136.727 142.26C136.953 142.199 137.179 142.138 137.406 142.078Z",
    fill: "url(#paint37_linear_2278_3893)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.456 158.561C136.556 159.472 135.545 160.228 134.424 160.829C133.57 161.261 132.695 161.617 131.799 161.896C133.54 160.561 135.425 159.45 137.456 158.561Z",
    fill: "url(#paint38_linear_2278_3893)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.4651 12.8259C95.8373 12.8885 95.2484 12.8038 94.6987 12.5714C95.3667 12.3836 95.9555 12.4685 96.4651 12.8259Z",
    fill: "url(#paint39_linear_2278_3893)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.132 156.095C141.026 156.951 139.874 157.785 138.678 158.597C138.43 159.266 137.97 159.511 137.298 159.331C136.347 160.063 135.354 160.733 134.319 161.342C134.354 161.171 134.389 161 134.424 160.829C135.545 160.228 136.556 159.472 137.456 158.561C137.482 158.351 137.613 158.235 137.848 158.214C137.871 158.42 137.987 158.551 138.195 158.606C138.962 158.112 139.615 157.533 140.155 156.867C140.358 156.466 140.695 156.214 141.166 156.111C141 156.365 141.041 156.516 141.287 156.564C141.522 156.32 141.803 156.164 142.132 156.095Z",
    fill: "url(#paint40_linear_2278_3893)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.8867 18.242C98.8302 18.4085 98.6994 18.5244 98.4947 18.5897C97.5932 18.5726 96.6925 18.5311 95.7926 18.4646C96.8033 18.2639 97.8349 18.1898 98.8867 18.242Z",
    fill: "url(#paint41_linear_2278_3893)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.542 161.844C131.197 162.474 130.674 162.938 129.974 163.234C129.879 163.179 129.783 163.124 129.687 163.069C130.166 162.457 130.784 162.048 131.542 161.844Z",
    fill: "url(#paint42_linear_2278_3893)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.8685 12.6526C89.3779 12.8866 88.9601 12.8368 88.6155 12.5031C89.0742 12.3565 89.492 12.4062 89.8685 12.6526Z",
    fill: "url(#paint43_linear_2278_3893)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.729 153.929C130.487 157.613 124.775 160.438 118.592 162.403C118.441 162.443 118.345 162.388 118.305 162.237C118.696 162.007 119.071 161.745 119.428 161.451C121.757 161.167 123.884 160.355 125.811 159.013C125.932 159.091 126.065 159.136 126.211 159.148C126.963 158.425 127.752 158.052 128.579 158.028C129.039 157.518 129.572 157.092 130.178 156.751C131.601 156.021 133.019 155.278 134.432 154.519C134.762 154.03 135.195 153.834 135.729 153.929Z",
    fill: "url(#paint44_linear_2278_3893)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.4 162.903C129.412 163.049 129.367 163.183 129.265 163.303C128.777 163.596 128.249 163.737 127.68 163.728C128.195 163.328 128.768 163.053 129.4 162.903Z",
    fill: "url(#paint45_linear_2278_3893)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.679 166.109C123.727 166.603 122.691 166.961 121.571 167.184C122.22 166.899 122.801 166.501 123.313 165.99C123.74 166.277 124.196 166.316 124.679 166.109Z",
    fill: "url(#paint46_linear_2278_3893)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.9405 13.0534C81.9525 13.1189 81.0269 13.2861 80.1637 13.5549C80.5788 13.351 81.0112 13.1543 81.4611 12.9646C81.9859 12.9158 82.479 12.9454 82.9405 13.0534Z",
    fill: "url(#paint47_linear_2278_3893)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.675 162.471C125.005 162.549 125.056 162.738 124.827 163.037C124.263 163.349 123.7 163.662 123.137 163.975C120.537 164.837 117.916 165.62 115.276 166.324C117.736 165.29 120.241 164.377 122.79 163.583C123.469 163.24 124.097 162.87 124.675 162.471Z",
    fill: "url(#paint48_linear_2278_3893)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.971 163.796C127.01 164.049 126.899 164.241 126.64 164.37C123.276 165.777 119.849 167.019 116.357 168.096C115.384 168.161 114.478 168.404 113.641 168.824C113.497 168.741 113.354 168.658 113.21 168.575C114.462 168.193 115.677 167.747 116.854 167.235C117.57 166.978 118.344 166.852 119.178 166.855C119.733 166.601 120.259 166.298 120.755 165.947C121.268 165.956 121.779 165.9 122.286 165.779C123.829 165.074 125.391 164.413 126.971 163.796Z",
    fill: "url(#paint49_linear_2278_3893)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.592 162.403C117.163 162.947 115.674 163.427 114.125 163.842C112.307 164.353 110.466 164.725 108.602 164.958C111.894 164.272 115.128 163.365 118.305 162.237C118.345 162.388 118.441 162.443 118.592 162.403Z",
    fill: "url(#paint50_linear_2278_3893)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.8172 17.3628C76.7768 17.2118 76.7364 17.061 76.6959 16.9101C78.0102 16.5458 79.3433 16.3909 80.6955 16.4449C80.2474 16.5339 79.8426 16.6826 79.4809 16.8916C78.5221 16.7094 77.6343 16.8665 76.8172 17.3628Z",
    fill: "url(#paint51_linear_2278_3893)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.7789 13.7086C76.5731 14.2922 75.3005 14.6736 73.9613 14.8529C73.8123 14.8 73.7066 14.707 73.644 14.574C75.1002 14.4158 76.4785 14.1274 77.7789 13.7086Z",
    fill: "url(#paint52_linear_2278_3893)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.6959 16.91C76.7364 17.061 76.7768 17.2118 76.8172 17.3627C70.1169 18.8359 70.0765 18.6849 76.6959 16.91Z",
    fill: "url(#paint53_linear_2278_3893)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.587 167.727C109.613 167.516 109.744 167.4 109.979 167.379C111.532 167.019 113.061 166.69 114.566 166.393C112.919 167.039 111.259 167.484 109.587 167.727Z",
    fill: "url(#paint54_linear_2278_3893)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.644 14.574C72.8093 14.7633 72.0575 15.1265 71.3887 15.6635C71.1014 15.6218 70.817 15.6171 70.5358 15.6494C71.4458 14.9063 72.4818 14.5479 73.644 14.574Z",
    fill: "url(#paint55_linear_2278_3893)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.331 168.563C116.182 169.091 114.977 169.575 113.718 170.016C111.823 170.183 110.009 170.507 108.277 170.989C111.319 170.185 114.336 169.376 117.331 168.563Z",
    fill: "url(#paint56_linear_2278_3893)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.979 167.379C109.744 167.4 109.613 167.516 109.587 167.727C108.804 168.012 108.029 168.139 107.263 168.107C108.101 167.679 109.006 167.437 109.979 167.379Z",
    fill: "url(#paint57_linear_2278_3893)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.0843 19.9706C66.7859 19.8239 66.464 19.8292 66.1183 19.9868C67.5874 19.295 69.1415 18.7573 70.7806 18.3737C69.5697 18.9601 68.3378 19.4923 67.0843 19.9706Z",
    fill: "url(#paint58_linear_2278_3893)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.345 164.906C106.127 165.586 103.813 166.004 101.403 166.159C103.698 165.666 106.012 165.248 108.345 164.906Z",
    fill: "url(#paint59_linear_2278_3893)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.262 168.107C106.339 168.313 105.403 168.442 104.455 168.495C105.379 168.089 106.315 167.96 107.262 168.107Z",
    fill: "url(#paint60_linear_2278_3893)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.3592 19.5385C62.0607 19.3917 61.7388 19.3971 61.3931 19.5547C64.3096 18.5867 67.2668 17.5517 70.2651 16.4497C70.3257 16.6761 70.3864 16.9024 70.447 17.1287C69.4327 17.5623 68.3867 17.883 67.3085 18.091C67.5395 17.8704 67.5092 17.7572 67.2175 17.7515C66.6543 18.0642 66.0913 18.3767 65.528 18.6894C64.4426 18.8141 63.3862 19.0972 62.3592 19.5385Z",
    fill: "url(#paint61_linear_2278_3893)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.0843 19.9707C65.2008 20.5692 63.3753 21.301 61.6075 22.1659C61.512 22.1108 61.4161 22.0554 61.3205 22.0002C62.7562 20.9669 64.3553 20.2958 66.1182 19.9869C66.4639 19.8293 66.7859 19.824 67.0843 19.9707Z",
    fill: "url(#paint62_linear_2278_3893)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.3592 19.5385C61.912 19.9818 61.3837 20.1233 60.7747 19.963C60.8804 19.7154 61.0865 19.5793 61.3931 19.5547C61.7388 19.3971 62.0608 19.3917 62.3592 19.5385Z",
    fill: "url(#paint63_linear_2278_3893)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.7747 19.9631C60.6815 20.3503 60.4202 20.5821 59.9906 20.6584C59.7441 20.6436 59.4975 20.6288 59.2509 20.614C59.679 20.407 60.1871 20.19 60.7747 19.9631Z",
    fill: "url(#paint64_linear_2278_3893)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.6674 166.018C99.571 166.199 99.4027 166.325 99.1622 166.396C98.3201 166.438 97.4774 166.462 96.6339 166.467C97.6209 166.203 98.632 166.053 99.6674 166.018Z",
    fill: "url(#paint65_linear_2278_3893)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.8595 172.057C98.1928 172.22 97.5487 172.23 96.9274 172.089C97.4511 171.909 97.9892 171.805 98.5422 171.778C98.6913 171.831 98.797 171.924 98.8595 172.057Z",
    fill: "url(#paint66_linear_2278_3893)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.5954 21.5681C56.5209 21.4088 56.5183 21.2477 56.5873 21.0851C57.4075 21.0577 58.23 20.9586 59.0549 20.7878C58.3044 21.316 57.4845 21.5762 56.5954 21.5681Z",
    fill: "url(#paint67_linear_2278_3893)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8758 28.9737C48.5774 28.8271 48.2554 28.8323 47.9098 28.99C49.892 27.5782 51.9634 26.2549 54.124 25.0202C56.3198 23.8513 58.5676 22.8851 60.8679 22.1215C56.7671 24.2161 52.7698 26.5002 48.8758 28.9737Z",
    fill: "url(#paint68_linear_2278_3893)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.5954 21.5682C56.6077 21.7147 56.5627 21.848 56.4601 21.9684C54.9847 22.6805 53.5868 23.4998 52.2667 24.4263C52.1509 24.2955 52.0349 24.165 51.919 24.0342C53.0651 23.2982 54.2465 22.5774 55.4637 21.8714C55.609 21.8833 55.7424 21.9284 55.8639 22.0068C55.966 21.525 56.2099 21.3788 56.5954 21.5682Z",
    fill: "url(#paint69_linear_2278_3893)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.973 166.164C90.9165 166.331 90.7857 166.446 90.581 166.512C89.6795 166.495 88.7788 166.453 87.8789 166.387C88.8896 166.186 89.9212 166.112 90.973 166.164Z",
    fill: "url(#paint70_linear_2278_3893)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.4663 24.1555C51.3607 24.4031 51.1545 24.5391 50.8479 24.5638C50.7197 24.3948 50.5487 24.3596 50.3346 24.4587C50.4929 24.1315 50.7542 23.8999 51.1187 23.7634C50.8586 24.1788 50.9743 24.3094 51.4663 24.1555Z",
    fill: "url(#paint71_linear_2278_3893)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.5499 172.049C91.496 172.399 90.5097 172.339 89.5911 171.872C90.2992 171.852 91.0011 171.907 91.697 172.035C91.9465 171.777 92.2309 171.782 92.5499 172.049Z",
    fill: "url(#paint72_linear_2278_3893)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5221 32.9754C47.6829 32.7346 47.8587 32.4854 48.0495 32.2276C53.3937 28.4405 59.1412 25.4448 65.2919 23.2407C62.6758 24.3745 60.0809 25.555 57.5073 26.7822C54.0797 28.6938 50.7513 30.7581 47.5221 32.9754Z",
    fill: "url(#paint73_linear_2278_3893)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.2891 165.554C83.2721 165.704 83.1792 165.81 83.0102 165.872C82.5396 165.829 82.0741 165.751 81.6137 165.64C82.1537 165.462 82.7121 165.434 83.2891 165.554Z",
    fill: "url(#paint74_linear_2278_3893)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.326 171.124C82.8584 171.607 82.3202 171.711 81.7112 171.436C81.8175 171.295 81.9584 171.216 82.1336 171.201C82.5498 171.021 82.9471 170.995 83.326 171.124Z",
    fill: "url(#paint75_linear_2278_3893)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5221 32.9755C47.2293 33.3314 46.9228 33.6967 46.6026 34.0709C45.4398 34.9174 44.2886 35.7516 43.1489 36.5732C43.0662 36.3829 43.1011 36.2117 43.254 36.0599C43.9362 35.6418 44.5243 35.1203 45.0182 34.4955C45.7545 33.8283 46.5891 33.3215 47.5221 32.9755Z",
    fill: "url(#paint76_linear_2278_3893)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.6031 34.5361C41.8392 35.3067 41.0754 36.0776 40.3115 36.8483C40.0851 36.9089 39.8588 36.9696 39.6324 37.0302C39.8735 36.7231 40.1148 36.4158 40.3559 36.1086C40.5311 36.0934 40.6719 36.0152 40.7783 35.8741C40.4361 35.804 40.3957 35.6533 40.657 35.4214C41.4153 34.8238 42.1341 34.1865 42.8132 33.5094C42.8757 33.6423 42.9814 33.7353 43.1305 33.7883C42.9398 34.0461 42.764 34.2953 42.6031 34.5361Z",
    fill: "url(#paint77_linear_2278_3893)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1962 32.002C40.7411 32.5569 40.2763 33.0857 39.8019 33.5886C39.6834 33.3981 39.5298 33.2777 39.341 33.2268C39.8602 32.7064 40.4786 32.2981 41.1962 32.002Z",
    fill: "url(#paint78_linear_2278_3893)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5985 37.014C40.558 36.863 40.4624 36.8078 40.3115 36.8483C41.0754 36.0776 41.8392 35.3067 42.6031 34.5361C42.8322 34.4385 43.0686 34.4155 43.3125 34.4673C42.3573 35.2674 41.4525 36.1163 40.5985 37.014Z",
    fill: "url(#paint79_linear_2278_3893)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5985 37.0141C39.213 38.2055 37.8307 39.3845 36.4517 40.5512C36.2315 40.6311 36.0227 40.606 35.8252 40.4765C35.5993 40.8439 35.2901 41.048 34.8976 41.0889C35.1335 40.6928 35.4603 40.4032 35.8777 40.2198C37.3121 39.4633 38.5638 38.4001 39.6325 37.0303C39.8588 36.9697 40.0851 36.909 40.3115 36.8484C40.4625 36.8079 40.558 36.8631 40.5985 37.0141Z",
    fill: "url(#paint80_linear_2278_3893)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1188 43.0409C36.7816 43.1805 36.5201 43.4124 36.3347 43.7362C36.1034 43.5907 36.1281 43.3818 36.4094 43.1097C37.1386 42.463 37.8572 41.8258 38.5657 41.1976C38.725 41.1231 38.8861 41.1205 39.0487 41.1895C38.4464 41.8632 37.8031 42.4803 37.1188 43.0409Z",
    fill: "url(#paint81_linear_2278_3893)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3559 36.1086C40.1148 36.4158 39.8735 36.7231 39.6324 37.0303C38.5638 38.4001 37.312 39.4633 35.8777 40.2197C36.1035 39.7822 36.3999 39.3792 36.7668 39.0111C36.9121 39.0229 37.0456 39.0681 37.167 39.1465C37.4782 38.2365 38.0536 37.5164 38.8927 36.9859C39.0381 36.9976 39.1715 37.0429 39.2929 37.1212C39.3123 36.348 39.6666 36.0105 40.3559 36.1086Z",
    fill: "url(#paint82_linear_2278_3893)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9664 38.7404C34.8537 40.1106 33.5367 41.2318 32.0157 42.1037C32.3358 41.7295 32.6423 41.3642 32.9351 41.0082C32.5409 41.0751 32.1736 41.2137 31.8337 41.4247C31.4328 41.8996 31.0333 42.3706 30.6354 42.8374C30.2389 42.9168 30.171 42.8137 30.4312 42.5283C31.5496 41.2509 32.6651 39.9816 33.7777 38.7204C34.3383 38.3074 34.871 37.8816 35.3762 37.443C35.445 37.9668 35.6419 38.3992 35.9664 38.7404Z",
    fill: "url(#paint83_linear_2278_3893)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8803 42.5038C31.8277 42.99 31.5762 43.2594 31.1265 43.3123C31.2565 42.9181 31.5076 42.6485 31.8803 42.5038Z",
    fill: "url(#paint84_linear_2278_3893)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3934 48.7246C30.5033 49.0578 30.4132 49.3245 30.1226 49.5249C29.7498 49.1648 29.8399 48.8981 30.3934 48.7246Z",
    fill: "url(#paint85_linear_2278_3893)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7762 53.3328C27.1662 53.7126 27.0657 53.9416 26.4752 54.02C26.6316 53.8063 26.7318 53.5771 26.7762 53.3328Z",
    fill: "url(#paint86_linear_2278_3893)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.174 54.7072C26.0458 55.0962 25.8628 55.4686 25.6244 55.8248C25.4444 55.3051 25.6277 54.9326 26.174 54.7072Z",
    fill: "url(#paint87_linear_2278_3893)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4137 59.4442C25.6707 65.1702 23.5925 71.1452 22.1784 77.3691C21.9668 77.1832 21.9061 76.9568 21.9965 76.69C23.3311 70.675 25.3947 64.9467 28.1873 59.5049C28.2627 59.4847 28.3383 59.4644 28.4137 59.4442Z",
    fill: "url(#paint88_linear_2278_3893)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3079 68.9194C19.3578 69.3726 19.2703 69.8004 19.0453 70.2028C18.8575 69.7272 18.9449 69.2993 19.3079 68.9194Z",
    fill: "url(#paint89_linear_2278_3893)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3906 81.2191C21.4038 80.1088 21.5559 79.0166 21.847 77.943C21.977 79.0562 21.8249 80.1481 21.3906 81.2191Z",
    fill: "url(#paint90_linear_2278_3893)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.617 71.7731C18.4772 71.4217 18.5095 71.0894 18.7139 70.7768C18.8921 71.1269 18.8598 71.4589 18.617 71.7731Z",
    fill: "url(#paint91_linear_2278_3893)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7841 69.5704C18.1192 69.7225 18.142 69.9589 17.8529 70.2797C17.6812 70.0645 17.6584 69.828 17.7841 69.5704Z",
    fill: "url(#paint92_linear_2278_3893)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6169 71.7732C18.7118 72.3581 18.6646 72.937 18.4756 73.5092C18.2425 72.9065 18.2896 72.3279 18.6169 71.7732Z",
    fill: "url(#paint93_linear_2278_3893)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3906 81.2191C21.4524 82.2673 21.3179 83.2738 20.9867 84.2385C20.8479 83.1799 20.9824 82.1735 21.3906 81.2191Z",
    fill: "url(#paint94_linear_2278_3893)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9866 84.2385C20.9969 85.9184 20.8732 87.569 20.6152 89.19C20.4643 87.4998 20.588 85.8492 20.9866 84.2385Z",
    fill: "url(#paint95_linear_2278_3893)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5976 71.3693C15.6123 71.1227 15.7228 70.9313 15.929 70.7953C16.0883 70.7208 16.2494 70.7181 16.412 70.7871C16.3852 71.6043 16.1136 71.7984 15.5976 71.3693Z",
    fill: "url(#paint96_linear_2278_3893)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6152 89.1901C20.7492 90.3521 20.7303 91.4894 20.5589 92.6015C20.3489 91.4378 20.3679 90.3007 20.6152 89.1901Z",
    fill: "url(#paint97_linear_2278_3893)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5589 92.6014C20.7218 93.2681 20.7325 93.9123 20.5914 94.5335C20.3631 93.8681 20.3521 93.224 20.5589 92.6014Z",
    fill: "url(#paint98_linear_2278_3893)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5914 94.5336C20.8127 96.6572 21.0191 98.7853 21.2103 100.918C20.6526 98.8027 20.4462 96.6746 20.5914 94.5336Z",
    fill: "url(#paint99_linear_2278_3893)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1946 144.286C32.7083 144.002 32.2852 143.63 31.9254 143.17C32.5577 143.283 32.9809 143.655 33.1946 144.286Z",
    fill: "url(#paint100_linear_2278_3893)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6341 101.825C19.915 103.605 20.1914 105.39 20.4632 107.183C20.3197 107.1 20.1762 107.017 20.0327 106.935C19.784 104.92 19.4948 102.936 19.1651 100.981C19.2014 101.359 19.3579 101.64 19.6341 101.825Z",
    fill: "url(#paint101_linear_2278_3893)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.137 83.9159C13.3907 84.6827 13.4797 85.4674 13.404 86.2704C13.3084 86.2152 13.2125 86.1598 13.117 86.1047C13.1774 86.5574 13.1754 87.0026 13.111 87.4405C13.5984 87.9856 13.6746 88.5717 13.3395 89.1988C13.3032 88.8206 13.1468 88.5392 12.8706 88.3541C12.6952 87.6568 12.6264 86.9474 12.6643 86.226C12.7782 85.4225 12.9358 84.6525 13.137 83.9159Z",
    fill: "url(#paint102_linear_2278_3893)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3395 89.1988C13.1983 89.6677 13.1308 90.171 13.1376 90.7085C12.9482 90.4455 12.8295 90.1537 12.7818 89.8334C12.6646 89.3102 12.6943 88.8171 12.8706 88.354C13.1468 88.5391 13.3032 88.8206 13.3395 89.1988Z",
    fill: "url(#paint103_linear_2278_3893)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.162 92.1575C13.2424 92.9013 13.2736 93.6208 13.2551 94.3159C12.6296 93.5975 12.5986 92.878 13.162 92.1575Z",
    fill: "url(#paint104_linear_2278_3893)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8851 125.508C20.528 125.249 20.4471 124.947 20.6425 124.602C20.8745 124.79 21.096 125.014 21.3074 125.273C21.2011 125.414 21.0603 125.492 20.8851 125.508Z",
    fill: "url(#paint105_linear_2278_3893)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9873 100.67C14.2115 102.712 14.5108 104.734 14.8851 106.737C14.7586 106.756 14.663 106.701 14.5981 106.571C14.3374 104.874 14.0059 103.184 13.6033 101.501C13.6862 101.357 13.769 101.214 13.8519 101.07C13.5581 100.894 13.4495 100.64 13.5264 100.308C13.6449 100.499 13.7985 100.619 13.9873 100.67Z",
    fill: "url(#paint106_linear_2278_3893)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7897 105.942C19.7852 104.278 19.632 102.572 19.33 100.824C19.0194 100.091 18.8201 99.3472 18.7318 98.5922C18.7323 97.1391 18.7164 95.6623 18.684 94.1619C18.5534 93.7886 18.5294 93.4154 18.6118 93.042C18.5548 92.8294 18.4979 92.6168 18.4409 92.4042C18.6123 90.9837 18.757 89.5397 18.8752 88.0726C18.8168 87.9139 18.7174 87.8266 18.5772 87.8107C18.5582 87.7399 18.5392 87.6689 18.5202 87.5981C18.9425 86.9479 18.9228 86.3074 18.4612 85.6771C18.527 85.3558 18.6826 85.0862 18.9281 84.8685C18.7881 84.8187 18.6887 84.7314 18.63 84.6065C19.0137 80.1128 19.9182 75.6932 21.3433 71.3476C22.4072 69.1021 23.2219 66.7572 23.7875 64.3128C24.9189 62.0417 26.1449 59.8145 27.4656 57.6309C27.0609 59.9083 26.279 62.0924 25.12 64.1836C24.6112 66.1794 24.0395 68.1555 23.4046 70.1117C23.0107 70.8942 22.8108 71.7072 22.805 72.5509C23.095 71.783 23.3847 71.0218 23.6741 70.2674C24.2941 69.2222 24.7913 68.1017 25.1658 66.9056C25.0846 67.957 24.8708 69.0018 24.5245 70.0395C25.1534 68.9981 25.6507 67.8775 26.0162 66.6777C26.2149 66.8523 26.2719 67.0649 26.1871 67.3155C25.1751 71.3918 24.3011 75.4995 23.5648 79.6386C23.7446 81.6771 23.6006 83.6905 23.1326 85.6786C23.2076 88.108 23.2128 90.5368 23.1484 92.9657C23.2658 94.4943 23.4874 96.0299 23.8131 97.5725C23.7139 96.37 23.6581 95.1696 23.6458 93.9717C23.4438 81.9462 26.1998 70.6886 31.9132 60.1988C32.017 60.019 32.1586 59.981 32.3384 60.0848C22.5247 81.3464 22.6423 102.619 32.6912 123.903C38.1597 134.471 45.7266 143.152 55.3918 149.948C57.2078 151.026 59.0402 152.054 60.8891 153.032C69.216 157.587 78.1509 160.32 87.6939 161.23C90.7497 161.541 93.8025 161.597 96.8525 161.396C119.779 159.976 137.715 149.815 150.661 130.914C152.127 128.531 153.448 126.089 154.622 123.587C157.245 118.476 159.183 113.096 160.437 107.446C160.521 107.196 160.464 106.983 160.266 106.809C158.938 112.654 156.986 118.266 154.409 123.644C153.837 124.478 153.309 125.342 152.825 126.233C152.687 126.427 152.536 126.429 152.371 126.241C163.92 102.97 163.266 79.98 150.41 57.2711C143.283 45.9665 133.708 37.4432 121.685 31.7014C121.37 31.3547 121.114 30.9675 120.918 30.5398C119.645 30.1356 118.584 29.4326 117.732 28.4312C99.4655 21.9309 81.4045 22.555 63.5493 30.3037C60.7365 31.6008 58.0114 33.0524 55.3743 34.6588C55.1427 34.645 54.9629 34.5412 54.8352 34.3475C56.1621 33.6354 57.494 32.9367 58.8306 32.2516C59.3996 31.931 59.8999 31.5313 60.332 31.0519C61.109 31.03 61.8504 30.6794 62.5565 30.0001C62.693 30.0111 62.8183 30.0537 62.9324 30.1272C64.7419 28.8667 66.7399 28.1035 68.9266 27.8375C69.2625 27.5607 69.6145 27.3146 69.9819 27.099C72.9652 26.0395 76.003 25.1877 79.0948 24.5433C77.344 24.762 75.6148 25.1114 73.9072 25.5916C72.4527 25.9813 71.0543 26.4321 69.7124 26.9434C63.9053 28.7888 58.5402 31.4417 53.6166 34.9019C52.6317 35.3283 51.8055 35.9295 51.1377 36.7054C49.6956 37.6484 48.2886 38.6329 46.9165 39.6593C46.3638 39.7985 45.9956 40.125 45.8118 40.6388C45.043 41.4518 44.1555 42.1073 43.1489 42.6056C42.8506 43.2264 42.4686 43.7845 42.0025 44.2799C41.127 44.959 40.249 45.65 39.368 46.3529C38.3697 47.6273 37.3315 48.8549 36.2534 50.0356C36.1965 49.823 36.1395 49.6104 36.0826 49.3978C37.4023 47.732 38.7992 46.1426 40.2733 44.6293C40.432 44.5088 40.465 44.3482 40.372 44.1471C41.7844 42.9336 43.1157 41.6655 44.3654 40.3429C45.3065 39.815 46.1137 39.143 46.7873 38.3268C46.9518 38.3125 47.0841 38.2391 47.184 38.1066C46.8676 37.9546 46.5885 37.7635 46.3468 37.5334C48.1618 36.1393 49.9891 34.7383 51.8284 33.3304C55.6405 30.9498 59.5269 28.7311 63.4882 26.6744C59.0096 28.2657 54.8913 30.4704 51.1336 33.2887C49.6365 34.2355 48.149 35.2038 46.6713 36.1933C46.0011 36.7294 45.4064 37.3445 44.8872 38.0384C44.6402 38.2163 44.3661 38.3278 44.0653 38.3726C43.8586 38.2541 43.6953 38.07 43.5755 37.8203C43.3139 38.1866 43.047 38.182 42.7745 37.807C42.8162 37.5776 42.9103 37.3623 43.0573 37.1616C44.43 36.4803 45.4542 35.4845 46.1301 34.1737C46.7237 33.9458 47.2525 33.6521 47.7169 33.2928C48.0309 33.2239 48.2953 33.0772 48.5103 32.8523C48.9524 32.7562 49.2688 32.5195 49.4594 32.1423C50.1637 31.6902 50.8861 31.2688 51.627 30.878C51.8476 30.858 51.9702 30.7491 51.9952 30.5515C53.9022 29.7169 55.6731 28.6728 57.3079 27.419C56.4665 27.6814 55.6447 28.0155 54.8422 28.4215C54.875 28.2607 54.9081 28.1001 54.9409 27.9393C57.8072 26.1437 60.8251 24.6515 63.9948 23.4627C64.4488 23.2676 64.8767 23.305 65.278 23.5745C65.7593 23.0945 66.3046 22.7205 66.9141 22.4526C68.2368 22.007 69.5641 21.5755 70.8963 21.1577C73.7091 20.3938 76.5435 19.6343 79.3999 18.8792C80.5419 18.9744 81.6238 18.7604 82.6457 18.2373C84.5134 18.0613 86.3801 17.941 88.2453 17.8762C88.304 18.001 88.4033 18.0883 88.5433 18.1381C89.0627 18.1122 89.5681 18.0146 90.0599 17.8456C91.4371 17.6443 92.8076 17.6569 94.1714 17.8833C94.471 18.1343 94.7381 18.1386 94.9724 17.8965C95.6261 18.0171 96.2853 18.0683 96.9503 18.0501C98.2378 18.179 99.528 18.1751 100.821 18.0383C101.473 18.0673 102.145 18.3053 102.835 18.7519C103.191 18.8732 103.564 18.8491 103.955 18.6796C104.595 18.7366 105.28 18.743 106.01 18.6984C106.325 18.8801 106.639 19.0615 106.954 19.2431C106.973 19.0538 107.042 18.8835 107.159 18.7325C107.874 18.9798 108.565 19.2886 109.23 19.6586C110.784 19.7563 112.301 20.0332 113.782 20.4897C117.833 22.0313 121.739 23.5671 125.497 25.0974C129.569 27.3583 133.551 29.7471 137.443 32.2638C140.16 34.7357 142.958 37.1 145.838 39.3566C147.213 40.9077 148.573 42.4421 149.919 43.9593C150.12 44.5519 150.517 44.9011 151.111 45.007C152.887 47.6553 154.693 50.2852 156.529 52.8972C158.247 55.7713 159.897 58.671 161.48 61.5961C161.316 61.6103 161.184 61.6838 161.084 61.8163C161.282 62.0598 161.49 62.2699 161.708 62.4464C162.957 65.8846 164.251 69.2974 165.591 72.6848C165.963 74.8926 166.471 77.0728 167.116 79.2258C167.467 81.1068 167.748 83.0063 167.959 84.924C168.024 85.2325 168.17 85.4971 168.399 85.7174C168.271 85.9905 168.196 86.2766 168.174 86.5754C168.393 87.497 168.64 88.4182 168.914 89.339C168.917 89.9761 168.749 90.059 168.411 89.5877C168.418 90.0354 168.497 90.4701 168.647 90.8918C168.629 91.5447 168.658 92.2204 168.734 92.919C169.138 93.6091 169.257 94.3367 169.091 95.1019C169.046 94.801 168.935 94.527 168.757 94.28C168.763 94.7848 168.7 95.2575 168.567 95.6979C168.253 96.287 168.324 96.8374 168.782 97.3493C168.721 97.7606 168.72 98.1788 168.776 98.604C168.687 98.5522 168.597 98.5002 168.507 98.4484C168.436 99.2025 168.519 99.9395 168.757 100.66C168.621 102.121 168.522 103.591 168.458 105.069C167.919 106.718 167.503 108.424 167.209 110.189C166.892 110.925 166.638 111.676 166.447 112.444C165.962 112.041 165.707 112.223 165.682 112.99C165.834 113.055 165.986 113.053 166.135 112.983C165.2 115.699 164.303 118.446 163.444 121.223C162.309 123.501 161.083 125.729 159.766 127.905C159.619 127.624 159.614 127.321 159.751 126.998C160.44 125.077 161.227 123.195 162.112 121.352C162.672 119.242 163.331 117.167 164.089 115.126C164.188 114.91 164.115 114.778 163.869 114.729C163.146 115.978 162.545 117.279 162.066 118.63C162.296 117.346 162.595 116.051 162.962 114.745C162.47 115.963 161.921 117.173 161.314 118.376C161.26 118.315 161.206 118.253 161.151 118.192C162.608 112.218 163.61 106.177 164.156 100.07C164.14 97.6316 164.17 95.193 164.247 92.7543C163.877 90.0424 163.494 87.3351 163.096 84.6321C162.786 82.7961 162.515 80.9321 162.281 79.0402C162.146 78.9623 162.011 78.8845 161.877 78.8067C162.132 80.4905 162.391 82.1677 162.655 83.8387C164.901 101.59 161.055 117.849 151.117 132.615C149.524 134.807 147.896 136.952 146.233 139.05C145.591 139.577 144.986 140.156 144.421 140.789C144.573 140.854 144.725 140.851 144.874 140.781C143.526 142.327 142.091 143.775 140.57 145.125C141.774 144.452 142.945 143.72 144.083 142.93C144.406 142.332 144.789 141.774 145.229 141.256C146.199 140.528 147.129 139.747 148.02 138.913C149.494 137.133 151.004 135.399 152.55 133.712C152.088 134.431 151.683 135.185 151.333 135.975C150.018 137.581 148.602 139.099 147.086 140.531C146.851 140.78 146.776 141.066 146.86 141.389C145.565 142.484 144.266 143.592 142.965 144.711C142.163 145.554 141.313 146.351 140.416 147.103C140.645 147.151 140.867 147.13 141.082 147.038C140.931 147.264 140.766 147.498 140.587 147.741C140.727 147.79 140.826 147.878 140.885 148.002C139.007 149.464 137.109 150.884 135.191 152.262C131.534 154.586 127.779 156.731 123.928 158.698C126.088 157.981 128.199 157.073 130.262 155.976C132.291 154.816 134.237 153.573 136.098 152.247C137.859 150.994 139.663 149.789 141.51 148.633C141.665 148.363 141.821 148.093 141.977 147.824C143.945 146.43 145.724 144.851 147.316 143.089C147.62 143.41 147.805 143.816 147.87 144.308C146.692 145.662 145.45 146.982 144.146 148.268C143.969 148.22 143.825 148.107 143.713 147.928C143.268 148.4 142.831 148.897 142.404 149.418C141.779 150.187 140.773 150.732 140.143 151.515C139.483 152.175 139.424 152.113 138.932 152.615C138.382 153.056 138.162 153.056 137.773 153.393C136.934 153.753 136.14 154.193 135.392 154.715C135.251 154.753 135.199 154.843 135.237 154.984C134.16 155.501 133.083 156.017 132.006 156.534C130.766 157.404 129.453 158.173 128.068 158.842C127.971 158.955 127.929 159.08 127.941 159.218C128.303 159.396 128.532 159.258 128.628 158.806C128.742 158.88 128.867 158.922 129.003 158.933C130.147 158.27 131.256 157.593 132.333 156.902C132.474 156.864 132.616 156.826 132.758 156.788C133.22 156.643 133.329 156.766 133.084 157.156C127.388 160.581 121.309 163.121 114.847 164.777C114.583 164.807 114.316 164.803 114.046 164.764C113.418 165.268 112.712 165.609 111.928 165.787C111.869 165.662 111.77 165.575 111.63 165.525C110.372 165.693 109.177 166.052 108.045 166.6C107.302 166.626 106.555 166.674 105.805 166.744C104.994 166.997 104.125 167.154 103.197 167.215C101.381 167.624 99.6039 167.796 97.8667 167.732C97.543 167.419 97.1507 167.372 96.6898 167.592C95.2536 167.783 93.7413 167.808 92.1532 167.668C91.637 167.45 91.0838 167.37 90.4942 167.429C89.0508 167.268 87.6 167.239 86.1417 167.342C85.5199 167.271 84.9385 167.085 84.3972 166.784C84.1001 166.671 83.7786 166.605 83.4329 166.587C83.0636 166.628 82.7067 166.572 82.3623 166.418C81.6777 166.933 81.0185 166.881 80.3844 166.264C80.2616 166.373 80.1391 166.482 80.0162 166.591C77.2572 165.83 74.4777 165.094 71.6774 164.382C66.3739 162.402 61.2175 160.024 56.2086 157.248C56.0519 157.074 55.9597 156.871 55.9314 156.639C52.9658 155.419 50.3386 153.692 48.0498 151.459C41.2051 146.32 35.5505 140.24 31.0862 133.219C29.3688 130.037 27.5811 126.908 25.7231 123.833C25.7091 123.258 25.6376 122.707 25.5084 122.182C24.73 120.355 23.8725 118.573 22.9359 116.833C23.0087 116.61 23.0226 116.379 22.9776 116.139C21.9153 112.734 20.8527 109.335 19.7897 105.942Z",
    fill: "url(#paint107_linear_2278_3893)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6888 124.611C25.0975 123.325 24.4591 121.999 23.7738 120.634C23.8183 120.336 23.8671 120.054 23.9202 119.787C24.6642 121.397 25.2536 123.005 25.6888 124.611Z",
    fill: "url(#paint108_linear_2278_3893)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2123 112.456C21.2294 112.838 21.3492 113.192 21.5719 113.519C21.4338 113.944 21.2517 113.922 21.0256 113.453C20.8705 113.129 20.8007 112.788 20.8164 112.43C20.9505 112.494 21.0824 112.503 21.2123 112.456Z",
    fill: "url(#paint109_linear_2278_3893)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8249 107.412C19.9644 107.391 20.083 107.45 20.1805 107.588C20.4461 109.035 20.68 110.468 20.8821 111.884C20.7425 111.905 20.624 111.846 20.5265 111.708C20.0322 110.215 19.6297 108.71 19.3189 107.196C19.5519 107.53 19.7205 107.601 19.8249 107.412Z",
    fill: "url(#paint110_linear_2278_3893)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0467 104.303C19.1357 104.409 19.2542 104.467 19.4023 104.479C19.2216 104.753 19.141 105.054 19.1607 105.381C19.7696 105.87 19.9544 106.484 19.7148 107.221C19.6018 106.951 19.4098 106.765 19.1391 106.664C18.9369 105.865 18.9062 105.078 19.0467 104.303Z",
    fill: "url(#paint111_linear_2278_3893)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5746 111.208C25.7311 111.604 25.978 111.885 26.3154 112.051C26.6373 113.205 27.0019 114.35 27.409 115.486C26.6951 114.08 26.0836 112.654 25.5746 111.208Z",
    fill: "url(#paint112_linear_2278_3893)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.907 89.0666C19.9804 89.1937 20.0805 89.2205 20.2076 89.1472C20.1234 89.9508 20.0406 90.7611 19.9591 91.5779C19.7464 90.7614 19.729 89.9244 19.907 89.0666Z",
    fill: "url(#paint113_linear_2278_3893)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9268 91.2732C21.155 91.7809 21.2531 92.3174 21.2206 92.8825C20.8626 92.3924 20.7647 91.856 20.9268 91.2732Z",
    fill: "url(#paint114_linear_2278_3893)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9269 91.2732C20.7352 90.8313 20.7424 90.4036 20.9485 89.99C21.1401 90.4319 21.133 90.8597 20.9269 91.2732Z",
    fill: "url(#paint115_linear_2278_3893)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9484 89.9901C20.7568 89.5483 20.764 89.1205 20.97 88.707C21.1616 89.1488 21.1544 89.5766 20.9484 89.9901Z",
    fill: "url(#paint116_linear_2278_3893)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.481 76.3294C23.242 76.3665 23.1369 76.2579 23.1656 76.0032C23.1765 75.5321 23.3706 75.2081 23.7482 75.0315C23.6054 75.4624 23.5162 75.8951 23.481 76.3294Z",
    fill: "url(#paint117_linear_2278_3893)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8543 74.3348C23.8637 73.564 24.1249 72.9895 24.6383 72.6115C24.5555 73.2718 24.294 73.8464 23.8543 74.3348Z",
    fill: "url(#paint118_linear_2278_3893)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7918 65.7772C26.9018 65.9678 27.0118 66.1584 27.1219 66.349C26.7519 67.2246 26.4282 68.1315 26.1512 69.0695C26.0684 69.2922 25.9231 69.3337 25.715 69.1943C26.086 68.0441 26.4449 66.905 26.7918 65.7772Z",
    fill: "url(#paint119_linear_2278_3893)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4713 63.49C25.3926 63.1326 25.5282 62.9273 25.8781 62.8739C25.8506 63.1538 25.715 63.3592 25.4713 63.49Z",
    fill: "url(#paint120_linear_2278_3893)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9252 61.1948C25.9892 60.8595 26.17 60.5858 26.4675 60.3734C26.5409 60.5006 26.641 60.5274 26.7681 60.454C26.8048 60.5174 26.8415 60.5811 26.8782 60.6446C26.7096 61.067 26.5386 61.5047 26.3653 61.9572C26.2652 61.9304 26.1648 61.9035 26.0647 61.8767C26.1636 61.6078 26.2625 61.3388 26.3614 61.07C26.1971 61.0469 26.0516 61.0885 25.9252 61.1948Z",
    fill: "url(#paint121_linear_2278_3893)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2558 52.8494C30.6161 53.141 30.8751 53.0763 31.033 52.6548C31.2133 52.8651 31.4187 53.0006 31.649 53.0615C30.9161 54.3505 30.121 55.6144 29.2636 56.8531C28.8519 58.3502 28.0568 59.6141 26.8782 60.6446C26.8415 60.5811 26.8048 60.5175 26.7681 60.454C27.0672 60.0424 27.3201 59.6001 27.5266 59.1266C27.0421 59.4254 26.6891 59.8409 26.4675 60.3734C26.17 60.5858 25.9892 60.8595 25.9251 61.1948C25.4287 61.7432 25.0722 62.3727 24.8552 63.0832C24.7416 63.1064 24.628 63.1298 24.5143 63.153C24.8092 62.6549 25.007 62.1171 25.1077 61.5397C26.09 59.6765 27.1647 57.8699 28.3322 56.1202C28.7459 54.8978 29.3871 53.8076 30.2558 52.8494Z",
    fill: "url(#paint122_linear_2278_3893)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4675 60.3735C26.6891 59.8409 27.0421 59.4254 27.5266 59.1267C27.3201 59.6001 27.0672 60.0425 26.7681 60.454C26.641 60.5274 26.5409 60.5006 26.4675 60.3735Z",
    fill: "url(#paint123_linear_2278_3893)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4054 61.9119C30.4841 62.2692 30.3485 62.4746 29.9986 62.5279C30.0261 62.248 30.1617 62.0427 30.4054 61.9119Z",
    fill: "url(#paint124_linear_2278_3893)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3265 58.7227C29.4903 58.7127 29.654 58.7031 29.8177 58.6932C29.6751 58.9717 29.5946 59.2724 29.5761 59.5951C29.718 59.7653 29.7277 59.929 29.6056 60.0864C29.4837 59.7476 29.1646 59.6352 28.6486 59.7494C28.829 59.3672 29.0549 59.0248 29.3265 58.7227Z",
    fill: "url(#paint125_linear_2278_3893)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4053 61.9119C30.7009 61.1059 31.1161 60.3579 31.6511 59.6678C31.4743 60.5328 31.0589 61.2809 30.4053 61.9119Z",
    fill: "url(#paint126_linear_2278_3893)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3265 58.7227C29.6919 57.9448 30.1155 57.0649 30.5978 56.0827C30.879 55.8228 31.2148 55.6711 31.6058 55.6278C31.0149 56.6427 30.4188 57.6646 29.8177 58.6932C29.654 58.7032 29.4903 58.7128 29.3265 58.7227Z",
    fill: "url(#paint127_linear_2278_3893)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.576 59.5952C29.5945 59.2725 29.6751 58.9718 29.8177 58.6933C30.4188 57.6646 31.0149 56.6427 31.6058 55.6278C31.9187 55.4144 32.1998 55.1675 32.4488 54.887C31.584 56.488 30.6263 58.0575 29.576 59.5952Z",
    fill: "url(#paint128_linear_2278_3893)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0381 54.6158C31.974 54.9511 31.7932 55.2248 31.4958 55.4372C31.246 55.3707 31.2178 55.1753 31.4113 54.8506C31.5648 54.6425 31.7738 54.5643 32.0381 54.6158Z",
    fill: "url(#paint129_linear_2278_3893)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9226 54.7985C33.9672 54.2546 34.2383 53.8439 34.7361 53.5665C34.719 53.8305 34.7021 54.0944 34.685 54.3584C34.7584 54.4855 34.7316 54.5856 34.6045 54.659C34.3698 54.5647 34.1426 54.6113 33.9226 54.7985Z",
    fill: "url(#paint130_linear_2278_3893)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4488 54.887C32.8882 53.9242 33.494 53.0662 34.2664 52.3128C33.827 53.2755 33.2212 54.1335 32.4488 54.887Z",
    fill: "url(#paint131_linear_2278_3893)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.2884 162.379C96.7071 162.017 97.2437 161.919 97.8977 162.085C97.404 162.314 96.8676 162.412 96.2884 162.379Z",
    fill: "url(#paint132_linear_2278_3893)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6058 55.6278C31.5692 55.5643 31.5324 55.5007 31.4958 55.4372C31.7932 55.2248 31.974 54.9512 32.0381 54.6158C32.1934 54.5595 32.3021 54.4542 32.3643 54.3004C32.0368 54.32 31.9635 54.193 32.1442 53.9192C32.6449 53.1608 33.1421 52.4079 33.6356 51.6604C33.9286 51.8201 34.2476 51.9325 34.5926 51.9974C34.5304 52.1512 34.4216 52.2564 34.2664 52.3128C33.494 53.0662 32.8882 53.9243 32.4488 54.887C32.1998 55.1675 31.9187 55.4144 31.6058 55.6278Z",
    fill: "url(#paint133_linear_2278_3893)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.685 54.3584C34.7021 54.0944 34.719 53.8305 34.7361 53.5665C35.7958 52.22 36.9001 50.9049 38.049 49.6207C36.9291 51.1989 35.8078 52.7782 34.685 54.3584Z",
    fill: "url(#paint134_linear_2278_3893)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6511 59.6678C32.4683 57.8946 33.4528 56.225 34.6043 54.659C34.7315 54.5856 34.7583 54.4855 34.6849 54.3583C35.8077 52.7782 36.929 51.1989 38.0489 49.6206C38.9603 49.0141 39.6027 48.2196 39.9765 47.237C40.4847 47.1937 40.8292 46.9102 41.0101 46.3862C41.1836 46.5401 41.3841 46.5939 41.6114 46.5473C40.0575 48.2511 38.5366 50.0186 37.0487 51.85C35.342 54.5553 33.5427 57.1612 31.6511 59.6678Z",
    fill: "url(#paint135_linear_2278_3893)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6414 46.8284C33.6412 47.012 33.5692 47.1806 33.4252 47.3344C33.5895 47.3575 33.735 47.3159 33.8615 47.2096C33.5059 47.677 33.0711 48.0975 32.5567 48.4712C32.2755 48.6135 32.0579 48.8238 31.9044 49.102C31.6383 49.1676 31.5833 49.0723 31.7393 48.8161C32.2579 48.0386 32.892 47.3762 33.6414 46.8284Z",
    fill: "url(#paint136_linear_2278_3893)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6413 46.8285C33.9226 46.6862 34.1402 46.4759 34.2937 46.1977C34.529 46.1813 34.6024 46.3084 34.5138 46.5789C34.3643 46.8517 34.1469 47.0619 33.8614 47.2097C33.735 47.316 33.5895 47.3575 33.4252 47.3345C33.5692 47.1807 33.6411 47.0121 33.6413 46.8285Z",
    fill: "url(#paint137_linear_2278_3893)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.859 166.718C103.198 166.646 103.526 166.627 103.842 166.659C103.89 166.769 103.863 166.869 103.761 166.959C103.382 167.012 103.009 167.101 102.643 167.224C102.787 167.07 102.859 166.901 102.859 166.718Z",
    fill: "url(#paint138_linear_2278_3893)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.201 162.084C101.18 161.944 101.239 161.826 101.377 161.728C101.814 161.653 102.255 161.61 102.7 161.6C102.253 161.892 101.754 162.053 101.201 162.084Z",
    fill: "url(#paint139_linear_2278_3893)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.049 49.6207C38.4932 48.6984 39.1356 47.9039 39.9766 47.2371C39.6028 48.2197 38.9604 49.0142 38.049 49.6207Z",
    fill: "url(#paint140_linear_2278_3893)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2468 45.6475C35.575 44.9121 36.0269 44.2278 36.6026 43.594C36.805 43.5933 36.9418 43.6838 37.0133 43.8652C36.3988 44.4344 35.8101 45.0284 35.2468 45.6475Z",
    fill: "url(#paint141_linear_2278_3893)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1606 46.3215C40.0609 42.6266 43.4682 39.4312 47.3824 36.735C44.0884 39.7469 40.9086 42.8958 37.8425 46.182C37.6079 46.0877 37.3806 46.1342 37.1606 46.3215Z",
    fill: "url(#paint142_linear_2278_3893)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2844 43.4545C37.8792 42.4097 38.6121 41.4782 39.4832 40.6602C40.1532 40.0604 40.8606 39.5249 41.6054 39.0537C40.3508 40.6879 38.9105 42.1548 37.2844 43.4545Z",
    fill: "url(#paint143_linear_2278_3893)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.898 165.704C110.452 165.494 111.007 165.428 111.562 165.505C111.002 165.838 110.447 165.904 109.898 165.704Z",
    fill: "url(#paint144_linear_2278_3893)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6414 46.8285C34.4369 45.7832 35.2787 44.7467 36.1663 43.7188C36.2285 43.0519 36.5866 42.7181 37.2402 42.7176C37.9253 41.8227 38.663 40.9731 39.4537 40.1689C39.4636 40.3327 39.4732 40.4964 39.4832 40.6602C38.6121 41.4782 37.8792 42.4097 37.2844 43.4545C37.3114 43.6518 37.2212 43.7888 37.0132 43.8652C36.9418 43.6838 36.8049 43.5933 36.6025 43.594C36.0269 44.2278 35.5749 44.9121 35.2467 45.6475C35.1602 46.0611 34.9159 46.3717 34.5138 46.5789C34.6024 46.3084 34.529 46.1813 34.2937 46.1977C34.1402 46.4759 33.9226 46.6862 33.6414 46.8285Z",
    fill: "url(#paint145_linear_2278_3893)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.384 161.379C106.395 161.214 106.486 161.077 106.656 160.968C107.478 160.764 108.305 160.583 109.137 160.425C108.269 160.852 107.351 161.17 106.384 161.379Z",
    fill: "url(#paint146_linear_2278_3893)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.851 39.0391C42.0109 38.3833 42.3725 37.8357 42.9356 37.3963C43.0357 37.4231 43.1361 37.45 43.2362 37.4769C42.9506 38.1485 42.4888 38.6693 41.851 39.0391Z",
    fill: "url(#paint147_linear_2278_3893)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.925 164.257C116.313 163.926 116.704 163.869 117.098 164.088C116.717 164.333 116.326 164.389 115.925 164.257Z",
    fill: "url(#paint148_linear_2278_3893)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9766 47.2371C43.8369 42.6204 48.3325 38.6693 53.4641 35.3839C53.5912 35.3105 53.6913 35.3373 53.7647 35.4644C53.4656 35.7677 53.1893 36.0965 52.9365 36.4509C50.8931 37.2738 49.1608 38.5281 47.7391 40.214C47.6099 40.1724 47.4779 40.1638 47.3432 40.1884C46.8369 41.0274 46.2116 41.5579 45.4667 41.7801C45.1734 42.355 44.7936 42.8707 44.327 43.3276C43.2132 44.3353 42.1075 45.3549 41.0101 46.3862C40.8293 46.9102 40.4847 47.1938 39.9766 47.2371Z",
    fill: "url(#paint149_linear_2278_3893)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5369 37.5574C43.4902 37.4276 43.4986 37.2957 43.5624 37.1615C43.9337 36.7776 44.3786 36.5208 44.8966 36.3912C44.5269 36.8789 44.0737 37.2675 43.5369 37.5574Z",
    fill: "url(#paint150_linear_2278_3893)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0404 33.5016C47.7839 32.8218 48.6368 32.2447 49.5988 31.7704C49.0794 32.1869 48.6495 32.6893 48.3088 33.2776C47.8515 33.121 47.4285 33.1957 47.0404 33.5016Z",
    fill: "url(#paint151_linear_2278_3893)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.112 162.209C122.993 161.91 123.792 161.533 124.51 161.08C124.183 161.365 123.838 161.649 123.476 161.93C123.012 162.102 122.557 162.195 122.112 162.209Z",
    fill: "url(#paint152_linear_2278_3893)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9286 36.8007C47.61 36.8096 47.5182 36.6506 47.6535 36.3242C48.0885 35.9036 48.5233 35.4833 48.9583 35.0627C51.1079 33.6482 53.2949 32.301 55.5193 31.0205C53.5381 32.556 51.4881 33.9937 49.369 35.3338C48.8358 35.8093 48.3557 36.2983 47.9286 36.8007Z",
    fill: "url(#paint153_linear_2278_3893)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5235 36.1562C45.4269 35.936 45.4806 35.7355 45.6846 35.555C48.394 33.4611 51.2017 31.5013 54.1075 29.6755C54.9746 29.3797 55.737 28.9395 56.3947 28.3549C56.545 28.3952 56.6954 28.4355 56.8457 28.4758C55.8026 29.1266 54.8093 29.8271 53.8658 30.5774C53.279 30.9841 52.6069 31.2872 51.8497 31.4873C51.408 31.8526 51.0048 32.2546 50.6403 32.6938C50.1723 32.811 49.7226 32.986 49.2913 33.2185C48.0632 34.2338 46.8074 35.2129 45.5235 36.1562Z",
    fill: "url(#paint154_linear_2278_3893)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4641 35.3839C54.628 34.5426 55.862 33.7453 57.1661 32.9924C58.6912 32.0866 60.2711 31.3016 61.9056 30.6372C59.0859 32.0598 56.3721 33.6688 53.7647 35.4644C53.6913 35.3373 53.5912 35.3105 53.4641 35.3839Z",
    fill: "url(#paint155_linear_2278_3893)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.62 156.812C126.693 156.939 126.767 157.066 126.84 157.193C125.736 157.843 124.565 158.307 123.325 158.587C123.71 158.397 124.041 158.164 124.318 157.887C125.232 157.819 125.999 157.46 126.62 156.812Z",
    fill: "url(#paint156_linear_2278_3893)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.636 160.36C127.588 159.538 128.65 158.882 129.821 158.394C129.969 158.406 130.088 158.465 130.177 158.57C128.894 159.068 127.714 159.664 126.636 160.36Z",
    fill: "url(#paint157_linear_2278_3893)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.84 157.193C126.767 157.066 126.693 156.939 126.62 156.812C132.341 153.846 132.414 153.973 126.84 157.193Z",
    fill: "url(#paint158_linear_2278_3893)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.3394 28.3647C60.3665 28.562 60.2763 28.699 60.0683 28.7754C58.7467 29.4799 57.4393 30.1501 56.1462 30.7857C57.4836 29.7985 58.8812 28.9916 60.3394 28.3647Z",
    fill: "url(#paint159_linear_2278_3893)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.177 158.57C130.888 158.195 131.482 157.683 131.958 157.033C132.229 157.001 132.488 156.937 132.735 156.839C132.09 157.734 131.237 158.311 130.177 158.57Z",
    fill: "url(#paint160_linear_2278_3893)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1102 29.4889C54.0248 28.7304 54.9997 27.998 56.0351 27.2919C57.7136 26.6796 59.28 25.9448 60.7343 25.0871C58.1707 26.5558 55.6294 28.023 53.1102 29.4889Z",
    fill: "url(#paint161_linear_2278_3893)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0683 28.7754C60.2763 28.699 60.3665 28.562 60.3395 28.3647C60.9801 27.9152 61.6522 27.6121 62.3555 27.4548C61.6992 28.0465 60.9367 28.4867 60.0683 28.7754Z",
    fill: "url(#paint162_linear_2278_3893)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.816 152.08C135.122 152.14 135.413 152.057 135.688 151.83C134.524 152.815 133.245 153.68 131.851 154.427C132.807 153.6 133.795 152.818 134.816 152.08Z",
    fill: "url(#paint163_linear_2278_3893)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.1512 30.6225C63.9982 29.4659 65.9959 28.5243 68.1444 27.7977C66.1831 28.8032 64.1853 29.7447 62.1512 30.6225Z",
    fill: "url(#paint164_linear_2278_3893)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.3555 27.4548C63.1433 27.0437 63.9608 26.6988 64.8078 26.4202C64.0683 27.0128 63.2509 27.3577 62.3555 27.4548Z",
    fill: "url(#paint165_linear_2278_3893)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.208 151.323C139.514 151.384 139.805 151.3 140.08 151.073C137.67 152.661 135.238 154.318 132.786 156.047C132.676 155.856 132.566 155.666 132.456 155.475C133.271 154.835 134.142 154.29 135.07 153.839C134.914 154.096 134.969 154.191 135.235 154.125C135.67 153.705 136.104 153.284 136.539 152.864C137.494 152.487 138.383 151.973 139.208 151.323Z",
    fill: "url(#paint166_linear_2278_3893)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.816 152.08C136.379 151.079 137.857 149.971 139.251 148.757C139.351 148.784 139.451 148.81 139.552 148.837C138.5 150.124 137.213 151.121 135.688 151.83C135.413 152.057 135.122 152.14 134.816 152.08Z",
    fill: "url(#paint167_linear_2278_3893)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.208 151.323C139.506 150.812 139.951 150.555 140.542 150.553C140.506 150.803 140.352 150.977 140.08 151.073C139.805 151.3 139.514 151.384 139.208 151.323Z",
    fill: "url(#paint168_linear_2278_3893)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.542 150.553C140.532 150.179 140.713 149.905 141.084 149.731C141.312 149.685 141.539 149.638 141.766 149.592C141.428 149.884 141.02 150.204 140.542 150.553Z",
    fill: "url(#paint169_linear_2278_3893)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.7538 27.5038C69.7972 27.3163 69.9194 27.1611 70.1202 27.0381C70.8738 26.7948 71.6326 26.5684 72.3967 26.3591C71.5654 26.8385 70.6845 27.22 69.7538 27.5038Z",
    fill: "url(#paint170_linear_2278_3893)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.0187 21.8289C69.584 21.5191 70.1657 21.3528 70.7636 21.3298C70.3323 21.6202 69.8694 21.8453 69.3744 22.0048C69.2263 21.993 69.1078 21.9343 69.0187 21.8289Z",
    fill: "url(#paint171_linear_2278_3893)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.943 148.081C144.05 148.207 144.091 148.353 144.068 148.517C143.331 148.741 142.609 149.031 141.902 149.386C142.454 148.725 143.135 148.289 143.943 148.081Z",
    fill: "url(#paint172_linear_2278_3893)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.146 139.486C149.453 139.546 149.744 139.463 150.019 139.236C148.564 140.999 147.006 142.703 145.346 144.348C143.638 145.942 141.834 147.365 139.933 148.617C143.144 145.72 146.215 142.676 149.146 139.486Z",
    fill: "url(#paint173_linear_2278_3893)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.943 148.081C143.897 147.951 143.905 147.819 143.969 147.685C145.134 146.68 146.203 145.597 147.176 144.436C147.313 144.526 147.45 144.616 147.586 144.707C146.726 145.653 145.829 146.594 144.896 147.53C144.762 147.555 144.63 147.547 144.5 147.505C144.525 147.967 144.339 148.159 143.943 148.081Z",
    fill: "url(#paint174_linear_2278_3893)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.6059 25.2576C77.6167 25.0928 77.7072 24.9559 77.8771 24.8469C78.6991 24.6433 79.5263 24.462 80.3589 24.3036C79.4907 24.7313 78.5729 25.0493 77.6059 25.2576Z",
    fill: "url(#paint175_linear_2278_3893)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.968 144.487C148.003 144.236 148.157 144.063 148.429 143.966C148.587 144.088 148.75 144.078 148.921 143.936C148.857 144.272 148.676 144.545 148.378 144.758C148.513 144.318 148.377 144.227 147.968 144.487Z",
    fill: "url(#paint176_linear_2278_3893)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.7448 20.3019C75.6159 19.7288 76.5251 19.5429 77.4722 19.7438C76.8345 19.9335 76.1845 20.0547 75.5219 20.1074C75.3583 20.4019 75.0992 20.4668 74.7448 20.3019Z",
    fill: "url(#paint177_linear_2278_3893)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.402 135.526C149.314 135.784 149.215 136.053 149.105 136.333C145.177 141.068 140.691 145.182 135.647 148.677C137.745 147.013 139.812 145.311 141.849 143.572C144.493 141.005 147.011 138.323 149.402 135.526Z",
    fill: "url(#paint178_linear_2278_3893)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.725 23.9429C84.7041 23.8033 84.7628 23.6848 84.9009 23.5872C85.3383 23.5116 85.7794 23.4688 86.2243 23.4585C85.7775 23.7508 85.2778 23.9122 84.725 23.9429Z",
    fill: "url(#paint179_linear_2278_3893)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.3377 18.8987C83.6446 18.347 84.1076 18.1221 84.727 18.2237C84.6648 18.3775 84.5561 18.4828 84.4008 18.5391C84.067 18.804 83.7128 18.9239 83.3377 18.8987Z",
    fill: "url(#paint180_linear_2278_3893)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.402 135.526C149.581 135.132 149.77 134.726 149.97 134.309C150.819 133.258 151.66 132.222 152.495 131.199C152.616 131.352 152.626 131.515 152.524 131.69C152.007 132.236 151.6 132.852 151.304 133.538C150.798 134.323 150.164 134.985 149.402 135.526Z",
    fill: "url(#paint181_linear_2278_3893)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.485 132.915C153.991 132.03 154.496 131.145 155.002 130.26C155.193 130.15 155.383 130.04 155.574 129.93C155.43 130.267 155.286 130.604 155.141 130.942C154.986 130.998 154.877 131.103 154.815 131.257C155.143 131.237 155.216 131.364 155.035 131.638C154.493 132.365 153.995 133.118 153.544 133.897C153.455 133.792 153.336 133.733 153.188 133.721C153.299 133.441 153.398 133.172 153.485 132.915Z",
    fill: "url(#paint182_linear_2278_3893)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.377 134.872C155.655 134.257 155.949 133.665 156.257 133.093C156.41 133.237 156.579 133.309 156.763 133.309C156.418 133.908 155.956 134.429 155.377 134.872Z",
    fill: "url(#paint183_linear_2278_3893)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.701 130.179C154.775 130.306 154.875 130.333 155.002 130.26C154.496 131.145 153.991 132.03 153.485 132.915C153.301 133.059 153.092 133.137 152.858 133.149C153.53 132.191 154.145 131.201 154.701 130.179Z",
    fill: "url(#paint184_linear_2278_3893)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.701 130.179C155.669 128.762 156.636 127.356 157.604 125.962C157.784 125.836 157.979 125.808 158.19 125.878C158.306 125.49 158.537 125.229 158.883 125.097C158.765 125.513 158.539 125.856 158.205 126.123C157.087 127.158 156.21 128.427 155.574 129.93C155.383 130.04 155.193 130.15 155.002 130.26C154.875 130.333 154.775 130.306 154.701 130.179Z",
    fill: "url(#paint185_linear_2278_3893)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.393 123.866C156.665 123.657 156.846 123.383 156.935 123.044C157.181 123.12 157.209 123.316 157.02 123.631C156.516 124.395 156.018 125.147 155.528 125.89C155.402 125.996 155.257 126.037 155.092 126.014C155.475 125.257 155.908 124.541 156.393 123.866Z",
    fill: "url(#paint186_linear_2278_3893)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.142 130.942C155.286 130.604 155.43 130.267 155.574 129.93C156.21 128.427 157.087 127.158 158.205 126.123C158.106 126.575 157.935 127.013 157.692 127.436C157.557 127.461 157.425 127.452 157.296 127.41C157.235 128.312 156.888 129.105 156.256 129.79C156.121 129.815 155.989 129.806 155.86 129.765C156.03 130.471 155.791 130.863 155.142 130.942Z",
    fill: "url(#paint187_linear_2278_3893)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.484 127.487C159.16 125.973 160.082 124.636 161.25 123.475C161.051 123.893 160.862 124.299 160.683 124.693C161.024 124.536 161.324 124.321 161.581 124.047C161.829 123.519 162.077 122.994 162.324 122.474C162.665 122.306 162.751 122.383 162.585 122.705C161.881 124.136 161.177 125.558 160.474 126.973C160.066 127.484 159.686 128 159.335 128.521C159.145 128.062 158.861 127.718 158.484 127.487Z",
    fill: "url(#paint188_linear_2278_3893)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.276 123.079C161.206 122.626 161.368 122.32 161.763 122.163C161.741 122.552 161.579 122.858 161.276 123.079Z",
    fill: "url(#paint189_linear_2278_3893)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.113 117.075C160.932 116.799 160.949 116.535 161.164 116.283C161.59 116.519 161.573 116.783 161.113 117.075Z",
    fill: "url(#paint190_linear_2278_3893)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.274 112.014C162.828 111.765 162.864 111.533 163.38 111.318C163.29 111.55 163.255 111.782 163.274 112.014Z",
    fill: "url(#paint191_linear_2278_3893)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.486 110.621C163.508 110.237 163.584 109.855 163.713 109.474C164.003 109.901 163.927 110.284 163.486 110.621Z",
    fill: "url(#paint192_linear_2278_3893)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.303 106.868C161.4 101.007 161.833 95.0808 161.602 89.0907C161.84 89.2079 161.95 89.3985 161.933 89.6626C162.184 95.4439 161.704 101.142 160.494 106.758C160.43 106.795 160.366 106.832 160.303 106.868Z",
    fill: "url(#paint193_linear_2278_3893)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.261 96.0586C166.105 95.6596 166.081 95.2502 166.187 94.8305C166.473 95.2163 166.498 95.6257 166.261 96.0586Z",
    fill: "url(#paint194_linear_2278_3893)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.381 85.4064C161.639 86.4169 161.767 87.4447 161.764 88.4895C161.375 87.5112 161.248 86.4836 161.381 85.4064Z",
    fill: "url(#paint195_linear_2278_3893)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.194 93.3017C166.406 93.5865 166.458 93.8958 166.348 94.2292C166.101 93.9549 166.05 93.6458 166.194 93.3017Z",
    fill: "url(#paint196_linear_2278_3893)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.485 95.0977C167.144 95.0411 167.066 94.8321 167.25 94.4708C167.458 94.6244 167.536 94.8334 167.485 95.0977Z",
    fill: "url(#paint197_linear_2278_3893)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.194 93.3016C165.966 92.794 165.868 92.2574 165.9 91.6923C166.258 92.1825 166.356 92.7188 166.194 93.3016Z",
    fill: "url(#paint198_linear_2278_3893)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.381 85.4065C161.07 84.4706 160.948 83.5248 161.014 82.569C161.397 83.4957 161.52 84.4414 161.381 85.4065Z",
    fill: "url(#paint199_linear_2278_3893)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.014 82.569C160.596 81.0474 160.307 79.52 160.147 77.9866C160.695 79.4834 160.984 81.0109 161.014 82.569Z",
    fill: "url(#paint200_linear_2278_3893)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.031 92.9342C169.078 93.1614 169.024 93.362 168.87 93.5355C168.744 93.6418 168.598 93.6833 168.434 93.6603C168.26 92.9124 168.459 92.6703 169.031 92.9342Z",
    fill: "url(#paint201_linear_2278_3893)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.147 77.9866C159.743 76.9649 159.484 75.9286 159.369 74.878C159.842 75.8827 160.101 76.9189 160.147 77.9866Z",
    fill: "url(#paint202_linear_2278_3893)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.369 74.8781C159.059 74.3128 158.893 73.7311 158.87 73.1331C159.239 73.6813 159.405 74.263 159.369 74.8781Z",
    fill: "url(#paint203_linear_2278_3893)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.87 73.1331C158.153 71.2603 157.448 69.3798 156.756 67.4916C157.776 69.2749 158.481 71.1554 158.87 73.1331Z",
    fill: "url(#paint204_linear_2278_3893)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.342 31.061C135.852 31.1998 136.326 31.4343 136.764 31.7644C136.163 31.8159 135.689 31.5815 135.342 31.061Z",
    fill: "url(#paint205_linear_2278_3893)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.966 66.2851C157.278 64.7393 156.593 63.1865 155.911 61.6261C156.061 61.6664 156.212 61.7067 156.362 61.7469C157.077 63.514 157.822 65.2441 158.596 66.9374C158.472 66.6032 158.261 66.3859 157.966 66.2851Z",
    fill: "url(#paint206_linear_2278_3893)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.214 80.9536C167.797 80.3196 167.525 79.6293 167.399 78.8825C167.499 78.9093 167.6 78.9362 167.7 78.963C167.535 78.567 167.428 78.1626 167.38 77.7497C166.806 77.3737 166.594 76.8605 166.746 76.2101C166.87 76.5444 167.081 76.7617 167.376 76.8625C167.705 77.4524 167.94 78.0792 168.081 78.7429C168.173 79.4995 168.217 80.2364 168.214 80.9536Z",
    fill: "url(#paint207_linear_2278_3893)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.746 76.21C166.76 75.7503 166.699 75.2773 166.562 74.7913C166.797 74.9838 166.976 75.2197 167.097 75.4987C167.331 75.9449 167.424 76.3995 167.376 76.8624C167.081 76.7616 166.87 76.5443 166.746 76.21Z",
    fill: "url(#paint208_linear_2278_3893)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.187 73.4827C165.934 72.8274 165.73 72.1823 165.578 71.5472C166.32 72.0468 166.523 72.692 166.187 73.4827Z",
    fill: "url(#paint209_linear_2278_3893)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.074 45.1044C151.461 45.2524 151.608 45.5066 151.514 45.8668C151.258 45.7527 151.002 45.6036 150.748 45.4198C150.81 45.266 150.919 45.1608 151.074 45.1044Z",
    fill: "url(#paint210_linear_2278_3893)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.369 65.9607C162.67 64.1629 161.907 62.4009 161.08 60.6749C161.19 60.6266 161.29 60.6534 161.381 60.7555C162.03 62.2319 162.741 63.6846 163.516 65.1138C163.476 65.2641 163.435 65.4144 163.395 65.5648C163.704 65.6528 163.864 65.8568 163.875 66.1769C163.722 66.0329 163.553 65.9609 163.369 65.9607Z",
    fill: "url(#paint211_linear_2278_3893)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M140.504 107.56L139.287 107.896C139.211 107.698 139.098 107.506 138.949 107.319C138.803 107.128 138.604 106.971 138.352 106.848C138.099 106.725 137.776 106.663 137.382 106.663C136.843 106.663 136.393 106.784 136.034 107.027C135.678 107.266 135.5 107.571 135.5 107.941C135.5 108.27 135.622 108.53 135.867 108.72C136.112 108.911 136.495 109.07 137.015 109.197L138.323 109.511C139.111 109.698 139.699 109.984 140.085 110.369C140.471 110.75 140.664 111.241 140.664 111.843C140.664 112.337 140.519 112.778 140.228 113.166C139.941 113.555 139.54 113.861 139.023 114.086C138.507 114.31 137.906 114.422 137.221 114.422C136.322 114.422 135.578 114.232 134.989 113.85C134.4 113.469 134.027 112.912 133.87 112.18L135.156 111.866C135.278 112.329 135.509 112.677 135.85 112.908C136.194 113.14 136.644 113.256 137.198 113.256C137.83 113.256 138.331 113.125 138.702 112.864C139.077 112.598 139.264 112.28 139.264 111.91C139.264 111.611 139.157 111.361 138.943 111.159C138.729 110.954 138.4 110.8 137.956 110.699L136.487 110.363C135.68 110.176 135.087 109.887 134.708 109.494C134.333 109.098 134.146 108.603 134.146 108.008C134.146 107.523 134.285 107.093 134.564 106.719C134.848 106.345 135.232 106.052 135.718 105.839C136.208 105.626 136.762 105.519 137.382 105.519C138.254 105.519 138.939 105.706 139.436 106.08C139.938 106.454 140.293 106.947 140.504 107.56Z",
    fill: "#1B1B1B"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M128.827 114.422C127.981 114.422 127.251 114.239 126.637 113.873C126.027 113.503 125.556 112.987 125.225 112.325C124.897 111.66 124.733 110.886 124.733 110.004C124.733 109.122 124.897 108.345 125.225 107.672C125.556 106.996 126.018 106.469 126.609 106.091C127.203 105.71 127.897 105.519 128.69 105.519C129.148 105.519 129.599 105.594 130.045 105.743C130.491 105.893 130.897 106.136 131.263 106.472C131.629 106.805 131.921 107.246 132.138 107.795C132.356 108.345 132.464 109.021 132.464 109.825V110.386H125.694V109.242H131.092C131.092 108.756 130.993 108.322 130.795 107.941C130.6 107.56 130.322 107.259 129.96 107.039C129.601 106.818 129.178 106.708 128.69 106.708C128.153 106.708 127.687 106.839 127.295 107.1C126.906 107.358 126.607 107.694 126.397 108.109C126.187 108.524 126.082 108.969 126.082 109.444V110.206C126.082 110.856 126.197 111.408 126.426 111.86C126.658 112.309 126.98 112.651 127.392 112.886C127.804 113.118 128.282 113.234 128.827 113.234C129.182 113.234 129.502 113.185 129.788 113.088C130.078 112.987 130.328 112.837 130.537 112.639C130.747 112.437 130.909 112.187 131.023 111.888L132.327 112.247C132.19 112.68 131.959 113.062 131.635 113.391C131.311 113.716 130.911 113.97 130.434 114.153C129.958 114.332 129.422 114.422 128.827 114.422Z",
    fill: "#1B1B1B"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M121.486 114.188V105.498H122.803V114.188H121.486ZM122.156 104.05C121.899 104.05 121.678 103.961 121.492 103.784C121.31 103.606 121.219 103.393 121.219 103.144C121.219 102.896 121.31 102.682 121.492 102.505C121.678 102.328 121.899 102.239 122.156 102.239C122.412 102.239 122.632 102.328 122.814 102.505C123 102.682 123.093 102.896 123.093 103.144C123.093 103.393 123 103.606 122.814 103.784C122.632 103.961 122.412 104.05 122.156 104.05Z",
    fill: "#1B1B1B"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M115.324 117.468C114.674 117.468 114.115 117.387 113.648 117.225C113.18 117.067 112.791 116.857 112.479 116.595C112.171 116.338 111.926 116.062 111.743 115.767L112.815 115.038C112.937 115.193 113.091 115.37 113.277 115.568C113.463 115.771 113.718 115.946 114.041 116.093C114.368 116.244 114.796 116.319 115.324 116.319C116.031 116.319 116.614 116.154 117.074 115.822C117.534 115.491 117.764 114.972 117.764 114.265V112.543H117.65C117.551 112.697 117.411 112.889 117.228 113.117C117.05 113.341 116.791 113.542 116.453 113.719C116.118 113.892 115.666 113.978 115.096 113.978C114.389 113.978 113.754 113.816 113.192 113.492C112.633 113.168 112.19 112.697 111.863 112.079C111.54 111.46 111.378 110.709 111.378 109.826C111.378 108.957 111.536 108.201 111.852 107.557C112.167 106.909 112.606 106.408 113.169 106.055C113.731 105.698 114.381 105.519 115.119 105.519C115.689 105.519 116.141 105.611 116.476 105.795C116.814 105.976 117.073 106.182 117.251 106.414C117.434 106.642 117.574 106.83 117.673 106.977H117.81V105.63H119.11V114.354C119.11 115.083 118.939 115.675 118.597 116.132C118.258 116.592 117.802 116.929 117.228 117.142C116.658 117.359 116.023 117.468 115.324 117.468ZM115.278 112.808C115.818 112.808 116.274 112.688 116.647 112.449C117.019 112.209 117.303 111.865 117.496 111.416C117.69 110.967 117.787 110.43 117.787 109.804C117.787 109.193 117.692 108.654 117.502 108.186C117.312 107.719 117.031 107.352 116.658 107.087C116.286 106.822 115.826 106.69 115.278 106.69C114.708 106.69 114.233 106.83 113.853 107.109C113.477 107.389 113.193 107.765 113.003 108.236C112.817 108.707 112.724 109.23 112.724 109.804C112.724 110.393 112.819 110.914 113.009 111.367C113.203 111.816 113.488 112.169 113.864 112.427C114.244 112.681 114.716 112.808 115.278 112.808Z",
    fill: "#1B1B1B"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M105.99 114.422C105.196 114.422 104.5 114.237 103.901 113.867C103.306 113.497 102.84 112.979 102.505 112.314C102.173 111.649 102.007 110.871 102.007 109.982C102.007 109.085 102.173 108.302 102.505 107.633C102.84 106.964 103.306 106.444 103.901 106.074C104.5 105.704 105.196 105.519 105.99 105.519C106.783 105.519 107.478 105.704 108.073 106.074C108.672 106.444 109.137 106.964 109.469 107.633C109.805 108.302 109.973 109.085 109.973 109.982C109.973 110.871 109.805 111.649 109.469 112.314C109.137 112.979 108.672 113.497 108.073 113.867C107.478 114.237 106.783 114.422 105.99 114.422ZM105.99 113.234C106.593 113.234 107.089 113.082 107.478 112.779C107.867 112.477 108.155 112.079 108.342 111.585C108.529 111.092 108.622 110.557 108.622 109.982C108.622 109.406 108.529 108.87 108.342 108.373C108.155 107.876 107.867 107.474 107.478 107.167C107.089 106.861 106.593 106.708 105.99 106.708C105.387 106.708 104.891 106.861 104.502 107.167C104.113 107.474 103.825 107.876 103.638 108.373C103.451 108.87 103.357 109.406 103.357 109.982C103.357 110.557 103.451 111.092 103.638 111.585C103.825 112.079 104.113 112.477 104.502 112.779C104.891 113.082 105.387 113.234 105.99 113.234Z",
    fill: "#1B1B1B"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M100.133 102.708V114.188H98.7269V102.708H100.133Z",
    fill: "#1B1B1B"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7525 114.422C91.9823 114.422 91.3065 114.237 90.7252 113.867C90.1475 113.497 89.6958 112.979 89.3699 112.314C89.0478 111.649 88.8867 110.871 88.8867 109.982C88.8867 109.085 89.0478 108.302 89.3699 107.633C89.6958 106.964 90.1475 106.444 90.7252 106.074C91.3065 105.704 91.9823 105.519 92.7525 105.519C93.5227 105.519 94.1966 105.704 94.7742 106.074C95.3556 106.444 95.8073 106.964 96.1295 107.633C96.4553 108.302 96.6182 109.085 96.6182 109.982C96.6182 110.871 96.4553 111.649 96.1295 112.314C95.8073 112.979 95.3556 113.497 94.7742 113.867C94.1966 114.237 93.5227 114.422 92.7525 114.422ZM92.7525 113.234C93.3375 113.234 93.8189 113.082 94.1966 112.779C94.5743 112.477 94.8538 112.079 95.0353 111.585C95.2167 111.092 95.3074 110.557 95.3074 109.982C95.3074 109.406 95.2167 108.87 95.0353 108.373C94.8538 107.876 94.5743 107.474 94.1966 107.167C93.8189 106.861 93.3375 106.708 92.7525 106.708C92.1674 106.708 91.6861 106.861 91.3084 107.167C90.9307 107.474 90.6511 107.876 90.4697 108.373C90.2882 108.87 90.1975 109.406 90.1975 109.982C90.1975 110.557 90.2882 111.092 90.4697 111.585C90.6511 112.079 90.9307 112.477 91.3084 112.779C91.6861 113.082 92.1674 113.234 92.7525 113.234Z",
    fill: "#1B1B1B"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5367 109.04V114.188H80.218V105.631H81.492V106.968H81.6037C81.8049 106.533 82.1103 106.184 82.5201 105.92C82.9298 105.653 83.4588 105.519 84.1069 105.519C84.688 105.519 85.1965 105.638 85.6323 105.876C86.0681 106.11 86.4071 106.466 86.6492 106.945C86.8913 107.421 87.0124 108.022 87.0124 108.75V114.188H85.6937V108.84C85.6937 108.167 85.5187 107.644 85.1685 107.268C84.8184 106.89 84.3379 106.7 83.727 106.7C83.306 106.7 82.9298 106.791 82.5983 106.973C82.2705 107.155 82.0116 107.421 81.8216 107.77C81.6317 108.119 81.5367 108.542 81.5367 109.04Z",
    fill: "#1B1B1B"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M72.148 109.008V114.188H70.8465V102.708H72.148V106.923H72.2583C72.4569 106.478 72.7547 106.125 73.1517 105.864C73.5525 105.598 74.0856 105.466 74.7511 105.466C75.3283 105.466 75.8338 105.583 76.2677 105.819C76.7015 106.051 77.0379 106.407 77.2769 106.89C77.5195 107.368 77.6409 107.977 77.6409 108.717V114.188H76.3394V108.807C76.3394 108.123 76.1647 107.594 75.8154 107.22C75.4698 106.843 74.99 106.654 74.376 106.654C73.9496 106.654 73.5672 106.746 73.2289 106.929C72.8944 107.112 72.6297 107.379 72.4348 107.73C72.2436 108.082 72.148 108.508 72.148 109.008Z",
    fill: "#1B1B1B"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4723 114.422C64.6937 114.422 64.0233 114.232 63.461 113.85C62.8987 113.469 62.4662 112.944 62.1634 112.275C61.8606 111.606 61.7092 110.842 61.7092 109.982C61.7092 109.107 61.8642 108.335 62.1742 107.666C62.4878 106.994 62.9239 106.469 63.4826 106.091C64.0449 105.71 64.7009 105.519 65.4506 105.519C66.0346 105.519 66.5608 105.631 67.0294 105.856C67.498 106.08 67.8818 106.394 68.181 106.797C68.4802 107.201 68.6658 107.672 68.7379 108.21H67.4619C67.3646 107.818 67.1483 107.47 66.8131 107.167C66.4815 106.861 66.0346 106.708 65.4723 106.708C64.9749 106.708 64.5387 106.842 64.1639 107.111C63.7926 107.377 63.5024 107.752 63.2934 108.238C63.0879 108.72 62.9852 109.287 62.9852 109.937C62.9852 110.602 63.0861 111.182 63.288 111.675C63.4934 112.168 63.7818 112.551 64.153 112.824C64.5279 113.097 64.9676 113.234 65.4723 113.234C65.8039 113.234 66.1048 113.174 66.3752 113.054C66.6455 112.935 66.8744 112.763 67.0618 112.538C67.2493 112.314 67.3826 112.045 67.4619 111.731H68.7379C68.6658 112.239 68.4874 112.697 68.2026 113.105C67.9215 113.508 67.5484 113.83 67.0835 114.069C66.6221 114.304 66.085 114.422 65.4723 114.422Z",
    fill: "#1B1B1B"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5424 114.422C55.7217 114.422 55.0137 114.239 54.4185 113.873C53.827 113.503 53.3705 112.987 53.0489 112.325C52.7309 111.66 52.572 110.886 52.572 110.004C52.572 109.122 52.7309 108.345 53.0489 107.672C53.3705 106.996 53.8178 106.469 54.3908 106.091C54.9675 105.71 55.6404 105.519 56.4093 105.519C56.8529 105.519 57.291 105.594 57.7235 105.743C58.1561 105.893 58.5498 106.136 58.9047 106.472C59.2596 106.805 59.5424 107.246 59.7531 107.795C59.9638 108.345 60.0692 109.021 60.0692 109.825V110.386H53.5036V109.242H58.7383C58.7383 108.756 58.6422 108.322 58.45 107.941C58.2614 107.56 57.9916 107.259 57.6404 107.039C57.2929 106.818 56.8825 106.708 56.4093 106.708C55.888 106.708 55.437 106.839 55.0563 107.1C54.6792 107.358 54.389 107.694 54.1856 108.109C53.9823 108.524 53.8807 108.969 53.8807 109.444V110.206C53.8807 110.856 53.9916 111.408 54.2134 111.86C54.4389 112.309 54.7513 112.651 55.1505 112.886C55.5498 113.118 56.0137 113.234 56.5424 113.234C56.8862 113.234 57.1967 113.185 57.474 113.088C57.755 112.987 57.9971 112.837 58.2004 112.639C58.4038 112.437 58.5609 112.187 58.6718 111.888L59.9361 112.247C59.803 112.68 59.5794 113.062 59.2651 113.391C58.9509 113.716 58.5627 113.97 58.1006 114.153C57.6385 114.332 57.1191 114.422 56.5424 114.422Z",
    fill: "#1B1B1B"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7807 105.517V106.661H46.4805V105.517H50.7807ZM47.7338 103.411H49.0087V111.79C49.0087 112.171 49.061 112.457 49.1654 112.648C49.2735 112.835 49.4103 112.961 49.576 113.026C49.7453 113.087 49.9235 113.117 50.1108 113.117C50.2513 113.117 50.3665 113.11 50.4566 113.094C50.5466 113.075 50.6186 113.06 50.6726 113.049L50.932 114.262C50.8455 114.296 50.7249 114.331 50.57 114.365C50.4151 114.403 50.2189 114.422 49.9812 114.422C49.621 114.422 49.268 114.34 48.9223 114.176C48.5802 114.012 48.2956 113.762 48.0687 113.426C47.8454 113.091 47.7338 112.667 47.7338 112.156V103.411Z",
    fill: "#1B1B1B"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M140.573 85.2C140.573 88.0035 140.067 90.4262 139.055 92.4683C138.042 94.5103 136.654 96.0851 134.888 97.1927C133.123 98.3002 131.107 98.854 128.84 98.854C126.573 98.854 124.557 98.3002 122.792 97.1927C121.027 96.0851 119.638 94.5103 118.626 92.4683C117.613 90.4262 117.107 88.0035 117.107 85.2C117.107 82.3965 117.613 79.9738 118.626 77.9317C119.638 75.8897 121.027 74.3149 122.792 73.2073C124.557 72.0998 126.573 71.546 128.84 71.546C131.107 71.546 133.123 72.0998 134.888 73.2073C136.654 74.3149 138.042 75.8897 139.055 77.9317C140.067 79.9738 140.573 82.3965 140.573 85.2ZM137.458 85.2C137.458 82.8984 137.073 80.9558 136.303 79.3724C135.542 77.789 134.508 76.5906 133.201 75.7772C131.903 74.9638 130.45 74.5572 128.84 74.5572C127.231 74.5572 125.773 74.9638 124.466 75.7772C123.168 76.5906 122.134 77.789 121.364 79.3724C120.603 80.9558 120.222 82.8984 120.222 85.2C120.222 87.5016 120.603 89.4441 121.364 91.0276C122.134 92.611 123.168 93.8094 124.466 94.6228C125.773 95.4362 127.231 95.8428 128.84 95.8428C130.45 95.8428 131.903 95.4362 133.201 94.6228C134.508 93.8094 135.542 92.611 136.303 91.0276C137.073 89.4441 137.458 87.5016 137.458 85.2Z",
    fill: "#1B1B1B"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7669 98.4905V71.9094H103.748C105.825 71.9094 107.53 72.2642 108.862 72.9737C110.195 73.6746 111.181 74.6394 111.821 75.868C112.462 77.0967 112.782 78.4941 112.782 80.0603C112.782 81.6264 112.462 83.0152 111.821 84.2266C111.181 85.4379 110.199 86.3897 108.875 87.082C107.551 87.7655 105.86 88.1073 103.8 88.1073H96.5321V85.2H103.697C105.116 85.2 106.258 84.9923 107.123 84.577C107.997 84.1617 108.629 83.5733 109.018 82.8118C109.416 82.0417 109.615 81.1246 109.615 80.0603C109.615 78.996 109.416 78.0658 109.018 77.2698C108.62 76.4737 107.984 75.8594 107.11 75.4268C106.236 74.9855 105.081 74.7648 103.645 74.7648H97.9857V98.4905H94.7669ZM107.279 86.5498L113.82 98.4905H110.082L103.645 86.5498H107.279Z",
    fill: "#1B1B1B"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7001 98.4905H68.4973V71.9094H77.0635C79.642 71.9094 81.8484 72.4416 83.6828 73.5058C85.5172 74.5615 86.9233 76.08 87.901 78.0615C88.8788 80.0343 89.3676 82.3965 89.3676 85.1481C89.3676 87.9169 88.8744 90.3008 87.888 92.2995C86.9016 94.2897 85.4653 95.8212 83.579 96.8941C81.6927 97.9584 79.3997 98.4905 76.7001 98.4905ZM71.7161 95.6352H76.4924C78.6902 95.6352 80.5116 95.2112 81.9566 94.3632C83.4016 93.5152 84.4789 92.3082 85.1884 90.742C85.8979 89.1759 86.2527 87.3112 86.2527 85.1481C86.2527 83.0022 85.9022 81.1548 85.2014 79.606C84.5005 78.0485 83.4535 76.8544 82.0604 76.0238C80.6673 75.1845 78.9325 74.7648 76.8558 74.7648H71.7161V95.6352Z",
    fill: "#1B1B1B"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6535 98.4905V71.9094H62.6956V74.7648H49.8723V83.7463H61.865V86.6017H49.8723V95.6352H62.9033V98.4905H46.6535Z",
    fill: "#1B1B1B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2278_3893",
    x1: 172.667,
    y1: 92.207,
    x2: 13.5557,
    y2: 92.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2278_3893",
    x1: 172.443,
    y1: 80.8949,
    x2: 171.537,
    y2: 81.1375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2278_3893",
    x1: 173.541,
    y1: 91.3058,
    x2: 172.855,
    y2: 91.4895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2278_3893",
    x1: 174.075,
    y1: 95.1347,
    x2: 172.264,
    y2: 95.6199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2278_3893",
    x1: 173.717,
    y1: 99.2335,
    x2: 172.359,
    y2: 99.5974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2278_3893",
    x1: 168.098,
    y1: 89.5795,
    x2: 167.306,
    y2: 89.7918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2278_3893",
    x1: 168.838,
    y1: 114.975,
    x2: 167.367,
    y2: 115.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2278_3893",
    x1: 167.822,
    y1: 112.943,
    x2: 167.243,
    y2: 113.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2278_3893",
    x1: 167.607,
    y1: 114.456,
    x2: 166.928,
    y2: 114.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2278_3893",
    x1: 167.231,
    y1: 115.77,
    x2: 166.552,
    y2: 115.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2278_3893",
    x1: 161.056,
    y1: 129.011,
    x2: 159.942,
    y2: 129.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2278_3893",
    x1: 159.929,
    y1: 131.07,
    x2: 158.344,
    y2: 131.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2278_3893",
    x1: 156.753,
    y1: 136.419,
    x2: 154.037,
    y2: 137.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2278_3893",
    x1: 155.178,
    y1: 141.408,
    x2: 154.499,
    y2: 141.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2278_3893",
    x1: 154.192,
    y1: 143.16,
    x2: 152.834,
    y2: 143.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2278_3893",
    x1: 156.836,
    y1: 144.877,
    x2: 145.292,
    y2: 147.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2278_3893",
    x1: 153.288,
    y1: 144.312,
    x2: 151.703,
    y2: 144.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2278_3893",
    x1: 150.243,
    y1: 141.096,
    x2: 149.564,
    y2: 141.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2278_3893",
    x1: 150.797,
    y1: 144.069,
    x2: 149.213,
    y2: 144.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2278_3893",
    x1: 149.798,
    y1: 142.154,
    x2: 147.535,
    y2: 142.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2278_3893",
    x1: 150.05,
    y1: 145.81,
    x2: 146.429,
    y2: 146.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2278_3893",
    x1: 150.195,
    y1: 145.444,
    x2: 145.215,
    y2: 146.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2278_3893",
    x1: 146.895,
    y1: 148.118,
    x2: 145.889,
    y2: 148.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2278_3893",
    x1: 144.1,
    y1: 148.047,
    x2: 142.742,
    y2: 148.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2278_3893",
    x1: 145.761,
    y1: 148.815,
    x2: 142.819,
    y2: 149.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2278_3893",
    x1: 109.474,
    y1: 19.7269,
    x2: 107.889,
    y2: 20.1515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2278_3893",
    x1: 146.984,
    y1: 148.851,
    x2: 142.457,
    y2: 150.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2278_3893",
    x1: 143.467,
    y1: 149.308,
    x2: 138.035,
    y2: 150.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2278_3893",
    x1: 148.657,
    y1: 146.947,
    x2: 133.039,
    y2: 151.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2278_3893",
    x1: 144.899,
    y1: 154.747,
    x2: 141.98,
    y2: 155.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2278_3893",
    x1: 140.026,
    y1: 145.521,
    x2: 105.395,
    y2: 154.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2278_3893",
    x1: 142.553,
    y1: 155.856,
    x2: 141.031,
    y2: 156.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2278_3893",
    x1: 104.345,
    y1: 13.2618,
    x2: 102.987,
    y2: 13.6257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2278_3893",
    x1: 104.396,
    y1: 18.8857,
    x2: 102.812,
    y2: 19.3103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2278_3893",
    x1: 138.52,
    y1: 152.575,
    x2: 135.578,
    y2: 153.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2278_3893",
    x1: 140.307,
    y1: 157.433,
    x2: 137.811,
    y2: 158.102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2278_3893",
    x1: 138.782,
    y1: 157.175,
    x2: 124.749,
    y2: 160.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2278_3893",
    x1: 138.103,
    y1: 144.681,
    x2: 122.938,
    y2: 148.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2278_3893",
    x1: 137.683,
    y1: 159.41,
    x2: 131.572,
    y2: 161.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2278_3893",
    x1: 96.3741,
    y1: 12.4862,
    x2: 94.7897,
    y2: 12.9108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2278_3893",
    x1: 142.496,
    y1: 157.452,
    x2: 133.894,
    y2: 159.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2278_3893",
    x1: 98.8412,
    y1: 18.0723,
    x2: 95.8987,
    y2: 18.8607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2278_3893",
    x1: 131.664,
    y1: 162.296,
    x2: 129.626,
    y2: 162.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2278_3893",
    x1: 89.8113,
    y1: 12.4391,
    x2: 88.6796,
    y2: 12.7423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2278_3893",
    x1: 136.198,
    y1: 155.677,
    x2: 117.864,
    y2: 160.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2278_3893",
    x1: 129.461,
    y1: 163.128,
    x2: 127.65,
    y2: 163.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2278_3893",
    x1: 124.653,
    y1: 166.009,
    x2: 121.484,
    y2: 166.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2278_3893",
    x1: 82.8799,
    y1: 12.8271,
    x2: 80.1637,
    y2: 13.5549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2278_3893",
    x1: 125.058,
    y1: 163.035,
    x2: 115.109,
    y2: 165.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2278_3893",
    x1: 127.153,
    y1: 164.475,
    x2: 113.119,
    y2: 168.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2278_3893",
    x1: 118.592,
    y1: 162.404,
    x2: 108.633,
    y2: 165.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2278_3893",
    x1: 80.6347,
    y1: 16.2183,
    x2: 76.7868,
    y2: 17.2493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2278_3893",
    x1: 77.7775,
    y1: 13.7033,
    x2: 73.7032,
    y2: 14.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2278_3893",
    x1: 76.7566,
    y1: 17.1364,
    x2: 71.7918,
    y2: 18.4667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2278_3893",
    x1: 114.554,
    y1: 166.346,
    x2: 109.574,
    y2: 167.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2278_3893",
    x1: 73.6791,
    y1: 14.705,
    x2: 70.5103,
    y2: 15.5541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2278_3893",
    x1: 117.392,
    y1: 168.789,
    x2: 108.338,
    y2: 171.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_2278_3893",
    x1: 109.993,
    y1: 167.434,
    x2: 107.277,
    y2: 168.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_2278_3893",
    x1: 70.8548,
    y1: 18.6505,
    x2: 66.1015,
    y2: 19.9241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_2278_3893",
    x1: 108.272,
    y1: 164.632,
    x2: 101.482,
    y2: 166.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_2278_3893",
    x1: 107.209,
    y1: 167.906,
    x2: 104.492,
    y2: 168.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_2278_3893",
    x1: 70.3864,
    y1: 16.9024,
    x2: 61.3325,
    y2: 19.3284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_2278_3893",
    x1: 67.1388,
    y1: 20.174,
    x2: 61.2537,
    y2: 21.7509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_2278_3893",
    x1: 62.3565,
    y1: 19.5283,
    x2: 60.772,
    y2: 19.9529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_2278_3893",
    x1: 60.8361,
    y1: 20.1921,
    x2: 59.2516,
    y2: 20.6167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_2278_3893",
    x1: 99.6522,
    y1: 165.961,
    x2: 96.7097,
    y2: 166.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_2278_3893",
    x1: 98.797,
    y1: 171.824,
    x2: 96.9863,
    y2: 172.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_2278_3893",
    x1: 59.0444,
    y1: 20.7486,
    x2: 56.5448,
    y2: 21.4184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_2278_3893",
    x1: 61.3227,
    y1: 23.8191,
    x2: 47.5155,
    y2: 27.5187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_2278_3893",
    x1: 56.7862,
    y1: 22.2802,
    x2: 51.8066,
    y2: 23.6145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_2278_3893",
    x1: 90.9275,
    y1: 165.994,
    x2: 87.985,
    y2: 166.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_2278_3893",
    x1: 51.4382,
    y1: 24.0506,
    x2: 50.3065,
    y2: 24.3539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_2278_3893",
    x1: 92.4297,
    y1: 171.601,
    x2: 89.7135,
    y2: 172.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_2278_3893",
    x1: 65.9136,
    y1: 25.5608,
    x2: 46.9004,
    y2: 30.6554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_2278_3893",
    x1: 83.2733,
    y1: 165.495,
    x2: 81.6889,
    y2: 165.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_2278_3893",
    x1: 83.3228,
    y1: 171.112,
    x2: 81.7384,
    y2: 171.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_2278_3893",
    x1: 47.8253,
    y1: 34.1072,
    x2: 42.8394,
    y2: 35.4432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_2278_3893",
    x1: 43.3731,
    y1: 34.6936,
    x2: 39.2989,
    y2: 35.7853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_2278_3893",
    x1: 41.3479,
    y1: 32.5678,
    x2: 39.3107,
    y2: 33.1137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_2278_3893",
    x1: 43.5231,
    y1: 35.2535,
    x2: 40.1279,
    y2: 36.1633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_2278_3893",
    x1: 40.8887,
    y1: 38.097,
    x2: 34.5509,
    y2: 39.7952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_2278_3893",
    x1: 39.2597,
    y1: 41.9768,
    x2: 35.996,
    y2: 42.8513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_2278_3893",
    x1: 40.7055,
    y1: 37.4134,
    x2: 35.4995,
    y2: 38.8084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_2278_3893",
    x1: 36.1181,
    y1: 39.3063,
    x2: 29.7963,
    y2: 41.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_2278_3893",
    x1: 31.9577,
    y1: 42.7927,
    x2: 31.0523,
    y2: 43.0353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_2278_3893",
    x1: 30.486,
    y1: 49.0636,
    x2: 29.9097,
    y2: 49.2181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_2278_3893",
    x1: 26.9833,
    y1: 53.5891,
    x2: 26.4015,
    y2: 53.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_2278_3893",
    x1: 26.2953,
    y1: 55.1598,
    x2: 25.4995,
    y2: 55.3731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_2278_3893",
    x1: 30.4455,
    y1: 67.0269,
    x2: 20.0334,
    y2: 69.8168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_2278_3893",
    x1: 19.4595,
    y1: 69.4853,
    x2: 18.884,
    y2: 69.6395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_2278_3893",
    x1: 22.2413,
    y1: 79.4143,
    x2: 20.9964,
    y2: 79.7478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_2278_3893",
    x1: 18.8595,
    y1: 71.223,
    x2: 18.487,
    y2: 71.3228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_2278_3893",
    x1: 18.0561,
    y1: 69.8614,
    x2: 17.703,
    y2: 69.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_2278_3893",
    x1: 18.8292,
    y1: 72.5654,
    x2: 18.2503,
    y2: 72.7205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_2278_3893",
    x1: 21.7545,
    y1: 82.5772,
    x2: 20.6228,
    y2: 82.8804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_2278_3893",
    x1: 21.5931,
    y1: 86.502,
    x2: 20.0087,
    y2: 86.9265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_2278_3893",
    x1: 16.4848,
    y1: 71.059,
    x2: 15.5794,
    y2: 71.3016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_2278_3893",
    x1: 21.0397,
    y1: 90.7745,
    x2: 20.1343,
    y2: 91.0171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_2278_3893",
    x1: 20.8015,
    y1: 93.5068,
    x2: 20.3405,
    y2: 93.6303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_2278_3893",
    x1: 21.4101,
    y1: 97.5893,
    x2: 20.3916,
    y2: 97.8622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_2278_3893",
    x1: 33.0127,
    y1: 143.607,
    x2: 32.1073,
    y2: 143.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_2278_3893",
    x1: 20.2102,
    y1: 103.976,
    x2: 19.3049,
    y2: 104.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_2278_3893",
    x1: 13.8138,
    y1: 86.4032,
    x2: 12.446,
    y2: 86.7696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_2278_3893",
    x1: 13.4204,
    y1: 89.4197,
    x2: 12.7082,
    y2: 89.6105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_2278_3893",
    x1: 13.4349,
    y1: 93.176,
    x2: 12.7616,
    y2: 93.3564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_2278_3893",
    x1: 21.2178,
    y1: 124.938,
    x2: 20.5637,
    y2: 125.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_2278_3893",
    x1: 14.7151,
    y1: 103.386,
    x2: 13.8097,
    y2: 103.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_2278_3893",
    x1: 165.818,
    y1: 73.5336,
    x2: 21.4697,
    y2: 112.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_2278_3893",
    x1: 25.1857,
    y1: 121.979,
    x2: 24.4233,
    y2: 122.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_2278_3893",
    x1: 21.4734,
    y1: 112.908,
    x2: 20.8963,
    y2: 113.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_2278_3893",
    x1: 21.0059,
    y1: 109.017,
    x2: 19.481,
    y2: 109.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_2278_3893",
    x1: 19.9526,
    y1: 105.432,
    x2: 18.8089,
    y2: 106.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_2278_3893",
    x1: 26.9206,
    y1: 113.099,
    x2: 26.2535,
    y2: 113.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_2278_3893",
    x1: 20.6478,
    y1: 89.9096,
    x2: 19.4089,
    y2: 90.6249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_2278_3893",
    x1: 21.312,
    y1: 91.9403,
    x2: 20.8244,
    y2: 92.2218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_2278_3893",
    x1: 21.2236,
    y1: 90.4666,
    x2: 20.6518,
    y2: 90.7967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_2278_3893",
    x1: 21.2451,
    y1: 89.1835,
    x2: 20.6733,
    y2: 89.5136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_2278_3893",
    x1: 23.9947,
    y1: 75.4584,
    x2: 23.0573,
    y2: 75.9997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_2278_3893",
    x1: 24.9134,
    y1: 73.088,
    x2: 23.5792,
    y2: 73.8583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_2278_3893",
    x1: 27.4474,
    y1: 66.9127,
    x2: 25.1601,
    y2: 68.2332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_2278_3893",
    x1: 25.9477,
    y1: 62.9945,
    x2: 25.3759,
    y2: 63.3247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_2278_3893",
    x1: 26.9882,
    y1: 60.8352,
    x2: 25.8446,
    y2: 61.4955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_2278_3893",
    x1: 32.7495,
    y1: 54.9676,
    x2: 23.0287,
    y2: 60.5799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_2278_3893",
    x1: 27.7192,
    y1: 59.4602,
    x2: 26.3849,
    y2: 60.2305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_2278_3893",
    x1: 30.5008,
    y1: 62.0772,
    x2: 29.929,
    y2: 62.4073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_2278_3893",
    x1: 30.0378,
    y1: 59.0744,
    x2: 28.7036,
    y2: 59.8447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_2278_3893",
    x1: 31.9812,
    y1: 60.2396,
    x2: 30.0752,
    y2: 61.3401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_2278_3893",
    x1: 32.0074,
    y1: 56.3234,
    x2: 28.9578,
    y2: 58.0841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_2278_3893",
    x1: 33.109,
    y1: 56.0306,
    x2: 28.9158,
    y2: 58.4516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_2278_3893",
    x1: 32.1063,
    y1: 54.7339,
    x2: 31.259,
    y2: 55.2232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_2278_3893",
    x1: 34.9561,
    y1: 53.9476,
    x2: 33.8125,
    y2: 54.6078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_2278_3893",
    x1: 34.5965,
    y1: 52.8846,
    x2: 32.1187,
    y2: 54.3152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_2278_3893",
    x1: 97.7531,
    y1: 161.835,
    x2: 96.4189,
    y2: 162.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_2278_3893",
    x1: 34.8126,
    y1: 52.3786,
    x2: 31.0006,
    y2: 54.5795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_2278_3893",
    x1: 38.6542,
    y1: 50.669,
    x2: 34.0798,
    y2: 53.3101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_2278_3893",
    x1: 43.097,
    y1: 49.1204,
    x2: 29.9454,
    y2: 56.7135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_2278_3893",
    x1: 33.9165,
    y1: 47.3049,
    x2: 31.4583,
    y2: 48.7242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_2278_3893",
    x1: 34.5988,
    y1: 46.4082,
    x2: 33.3175,
    y2: 47.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_2278_3893",
    x1: 103.787,
    y1: 166.563,
    x2: 102.643,
    y2: 167.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_2278_3893",
    x1: 102.564,
    y1: 161.364,
    x2: 101.23,
    y2: 162.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_2278_3893",
    x1: 40.2517,
    y1: 47.7136,
    x2: 37.7739,
    y2: 49.1442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_2278_3893",
    x1: 37.0736,
    y1: 43.9574,
    x2: 34.9717,
    y2: 45.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_2278_3893",
    x1: 48.2352,
    y1: 38.2121,
    x2: 36.4178,
    y2: 45.0349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_2278_3893",
    x1: 42.018,
    y1: 39.7685,
    x2: 36.8718,
    y2: 42.7397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_2278_3893",
    x1: 111.397,
    y1: 165.219,
    x2: 110.063,
    y2: 165.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_2278_3893",
    x1: 40.2245,
    y1: 41.5041,
    x2: 32.9816,
    y2: 45.6858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_2278_3893",
    x1: 108.945,
    y1: 160.091,
    x2: 106.467,
    y2: 161.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_2278_3893",
    x1: 43.3463,
    y1: 37.6675,
    x2: 41.6309,
    y2: 38.6579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_2278_3893",
    x1: 116.981,
    y1: 163.887,
    x2: 116.028,
    y2: 164.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_2278_3893",
    x1: 54.5654,
    y1: 36.8512,
    x2: 39.1265,
    y2: 45.7648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_2278_3893",
    x1: 44.9521,
    y1: 36.4872,
    x2: 43.4273,
    y2: 37.3676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_2278_3893",
    x1: 49.7574,
    y1: 32.0451,
    x2: 47.089,
    y2: 33.5858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_2278_3893",
    x1: 124.51,
    y1: 161.08,
    x2: 122.223,
    y2: 162.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_2278_3893",
    x1: 55.8219,
    y1: 31.5446,
    x2: 47.4439,
    y2: 36.3817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_2278_3893",
    x1: 57.0107,
    y1: 28.7617,
    x2: 45.1934,
    y2: 35.5844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_2278_3893",
    x1: 61.8499,
    y1: 30.5407,
    x2: 53.4634,
    y2: 35.3827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_2278_3893",
    x1: 126.675,
    y1: 156.907,
    x2: 123.435,
    y2: 158.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_2278_3893",
    x1: 130.069,
    y1: 158.384,
    x2: 126.638,
    y2: 160.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_2278_3893",
    x1: 130.911,
    y1: 154.588,
    x2: 126.73,
    y2: 157.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_2278_3893",
    x1: 60.362,
    y1: 28.4037,
    x2: 56.1687,
    y2: 30.8247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_2278_3893",
    x1: 132.781,
    y1: 156.919,
    x2: 130.113,
    y2: 158.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_2278_3893",
    x1: 60.6246,
    y1: 24.897,
    x2: 53.0005,
    y2: 29.2988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_2278_3893",
    x1: 62.3288,
    y1: 27.4085,
    x2: 60.0416,
    y2: 28.7291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_2278_3893",
    x1: 135.719,
    y1: 151.883,
    x2: 131.716,
    y2: 154.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_2278_3893",
    x1: 68.0025,
    y1: 27.5518,
    x2: 62.2844,
    y2: 30.8532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_2278_3893",
    x1: 64.7405,
    y1: 26.3036,
    x2: 62.4533,
    y2: 27.6241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_2278_3893",
    x1: 140.19,
    y1: 151.264,
    x2: 132.566,
    y2: 155.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_2278_3893",
    x1: 139.673,
    y1: 149.047,
    x2: 134.717,
    y2: 151.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_2278_3893",
    x1: 140.547,
    y1: 150.561,
    x2: 139.213,
    y2: 151.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_2278_3893",
    x1: 141.765,
    y1: 149.59,
    x2: 140.431,
    y2: 150.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_2278_3893",
    x1: 72.2591,
    y1: 26.1208,
    x2: 69.7813,
    y2: 27.5514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_2278_3893",
    x1: 70.6569,
    y1: 21.145,
    x2: 69.1321,
    y2: 22.0253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_2278_3893",
    x1: 144.026,
    y1: 148.204,
    x2: 141.921,
    y2: 149.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_2278_3893",
    x1: 150.734,
    y1: 140.475,
    x2: 139.107,
    y2: 147.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_2278_3893",
    x1: 147.79,
    y1: 145.06,
    x2: 143.597,
    y2: 147.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_2278_3893",
    x1: 80.1663,
    y1: 23.97,
    x2: 77.6885,
    y2: 25.4006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_2278_3893",
    x1: 148.972,
    y1: 144.025,
    x2: 148.019,
    y2: 144.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_2278_3893",
    x1: 77.2501,
    y1: 19.3592,
    x2: 74.9629,
    y2: 20.6797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_2278_3893",
    x1: 150.53,
    y1: 137.48,
    x2: 134.519,
    y2: 146.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_2278_3893",
    x1: 86.0879,
    y1: 23.2223,
    x2: 84.7537,
    y2: 23.9926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_2278_3893",
    x1: 84.6777,
    y1: 18.1384,
    x2: 83.3435,
    y2: 18.9087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_2278_3893",
    x1: 153.05,
    y1: 132.149,
    x2: 148.852,
    y2: 134.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_2278_3893",
    x1: 156.179,
    y1: 130.978,
    x2: 152.748,
    y2: 132.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_2278_3893",
    x1: 156.818,
    y1: 133.405,
    x2: 155.102,
    y2: 134.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_2278_3893",
    x1: 155.335,
    y1: 130.837,
    x2: 152.476,
    y2: 132.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_2278_3893",
    x1: 159.512,
    y1: 126.186,
    x2: 154.175,
    y2: 129.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_2278_3893",
    x1: 157.458,
    y1: 123.765,
    x2: 154.709,
    y2: 125.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_2278_3893",
    x1: 158.891,
    y1: 127.312,
    x2: 154.507,
    y2: 129.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_2278_3893",
    x1: 163.532,
    y1: 123.937,
    x2: 158.209,
    y2: 127.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_2278_3893",
    x1: 161.898,
    y1: 122.396,
    x2: 161.136,
    y2: 122.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_2278_3893",
    x1: 161.432,
    y1: 116.509,
    x2: 160.946,
    y2: 116.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_2278_3893",
    x1: 163.514,
    y1: 111.549,
    x2: 163.024,
    y2: 111.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_2278_3893",
    x1: 163.936,
    y1: 109.853,
    x2: 163.266,
    y2: 110.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_2278_3893",
    x1: 165.384,
    y1: 95.4209,
    x2: 156.617,
    y2: 100.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_2278_3893",
    x1: 166.47,
    y1: 95.3022,
    x2: 165.986,
    y2: 95.5821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_2278_3893",
    x1: 162.097,
    y1: 86.6453,
    x2: 161.048,
    y2: 87.2506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_2278_3893",
    x1: 166.421,
    y1: 93.6787,
    x2: 166.108,
    y2: 93.8598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_2278_3893",
    x1: 167.465,
    y1: 94.7281,
    x2: 167.167,
    y2: 94.8998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_2278_3893",
    x1: 166.296,
    y1: 92.353,
    x2: 165.809,
    y2: 92.6345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_2278_3893",
    x1: 161.674,
    y1: 83.7127,
    x2: 160.721,
    y2: 84.2629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_2278_3893",
    x1: 161.248,
    y1: 79.8926,
    x2: 159.913,
    y2: 80.6629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_2278_3893",
    x1: 169.064,
    y1: 92.9912,
    x2: 168.302,
    y2: 93.4313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_2278_3893",
    x1: 160.139,
    y1: 76.2122,
    x2: 159.377,
    y2: 76.6524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_2278_3893",
    x1: 159.317,
    y1: 73.8915,
    x2: 158.929,
    y2: 74.1156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_2278_3893",
    x1: 158.242,
    y1: 70.0647,
    x2: 157.384,
    y2: 70.5599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_2278_3893",
    x1: 136.434,
    y1: 31.1926,
    x2: 135.672,
    y2: 31.6328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_2278_3893",
    x1: 157.683,
    y1: 64.0342,
    x2: 156.92,
    y2: 64.4743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_2278_3893",
    x1: 168.147,
    y1: 78.1967,
    x2: 166.995,
    y2: 78.8616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_2278_3893",
    x1: 167.218,
    y1: 75.683,
    x2: 166.618,
    y2: 76.0293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_2278_3893",
    x1: 166.259,
    y1: 72.2976,
    x2: 165.692,
    y2: 72.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_2278_3893",
    x1: 151.461,
    y1: 45.3836,
    x2: 150.91,
    y2: 45.7016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_2278_3893",
    x1: 162.811,
    y1: 63.2333,
    x2: 162.049,
    y2: 63.6735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdroL);
export default __webpack_public_path__ + "static/media/edroL.c5aeb5fcc9e84d71f8c47e3b394c8fc4.svg";
export { ForwardRef as ReactComponent };